<div class="header bg-gradient-danger pb-1 pt-5 pt-md-8">
  <div class="container-fluid">
    <div class="header-body"></div>
  </div>
</div>

<div class="container-fluid" style="margin-top: -4.1em">
  <!-- Icons is Used as Admin -->
  <mat-tab-group dynamicHeight [(selectedIndex)]="demo1TabIndex" (selectedTabChange)="onTabClick($event)">
    <mat-tab label="Send Message">

      <div class="wa-page-wrapper">

        <!-- ADD CAMPAIGN CARD -->
        <div class="wa-card">
          <div class="wa-card-header">
            <div class="wa-icon-badge add-badge">
              <i class="fa-solid fa-plus"></i>
            </div>
            <div>
              <h3 class="wa-card-title">Add Campaign</h3>
              <p class="wa-card-subtitle">Create a new WhatsApp campaign group</p>
            </div>
          </div>

          <div class="wa-campaign-row">
            <div class="wa-input-wrapper">
              <i class="fa-solid fa-bullhorn wa-input-icon"></i>
              <input type="text" class="wa-campaign-input" placeholder="Enter campaign name"
                [(ngModel)]="campaignName" />
            </div>
            <button class="wa-add-btn" (click)="addCampaign()">
              <i class="fa-solid fa-plus"></i> Add Campaign
            </button>
          </div>

          <!-- Campaign list with edit / delete buttons -->
          <div class="wa-campaign-list" *ngIf="campaignList.length > 0">
            <div class="wa-campaign-item" *ngFor="let campaign of campaignList">

              <!-- Normal view -->
              <ng-container *ngIf="!editingCampaign || editingCampaign.id !== campaign.id">
                <span class="wa-campaign-item-name">
                  <i class="fa-solid fa-bullhorn"></i> {{ campaign.name }}
                </span>
                <div class="wa-campaign-actions">
                  <button class="wa-campaign-edit-btn" type="button" title="Edit campaign"
                    (click)="startEditCampaign(campaign)">
                    <i class="fa-solid fa-pen"></i>
                  </button>
                  <button class="wa-campaign-delete-btn" type="button" title="Delete campaign"
                    (click)="deleteCampaign(campaign)">
                    <i class="fa-solid fa-trash"></i>
                  </button>
                </div>
              </ng-container>

              <!-- Inline edit view -->
              <ng-container *ngIf="editingCampaign && editingCampaign.id === campaign.id">
                <input class="wa-campaign-edit-input" type="text" [(ngModel)]="editCampaignName"
                  (keyup.enter)="saveEditCampaign()" (keyup.escape)="cancelEditCampaign()" />
                <div class="wa-campaign-actions">
                  <button class="wa-campaign-save-btn" type="button" title="Save" (click)="saveEditCampaign()">
                    <i class="fa-solid fa-check"></i>
                  </button>
                  <button class="wa-campaign-cancel-btn" type="button" title="Cancel" (click)="cancelEditCampaign()">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>
              </ng-container>

            </div>
          </div>

        </div>

        <!-- WHATSAPP CAMPAIGN CARD -->
        <div class="wa-card">
          <div class="wa-card-header">
            <div class="wa-icon-badge wa-badge">
              <i class="fa-brands fa-whatsapp"></i>
            </div>
            <div>
              <h2 class="wa-card-title">WhatsApp Campaign</h2>
              <p class="wa-card-subtitle">Send WhatsApp messages using AISensy API</p>
            </div>
          </div>

          <div class="wa-divider"></div>

          <div class="wa-form-grid">

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-flag"></i> Campaign Name
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.campaignId">
                  <option value="">Select Campaign</option>
                  <option *ngFor="let campaign of campaignList" [value]="campaign.id">{{ campaign.name }}</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-building"></i> Department
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.departmentId" (change)="onDepartmentChange()">
                  <option value="">Select Department</option>
                  <option *ngFor="let dept of departmentList" [value]="dept.dep_id">{{ dept.dep_name }}</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <!-- Issue Seller Type — Representative department -->
            <div class="wa-form-group" *ngIf="isRepresentativeDept">
              <label class="wa-label"><i class="fa-solid fa-users"></i> Issue Seller Type</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="issueSellerTypeDropdownOpen = !issueSellerTypeDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.issueSellerTypeIds.length">{{
                    selectedIssueSellerTypeLabel }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="issueSellerTypeDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="issueSellerTypeDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="issueSellerTypeSearch"
                      placeholder="Search type..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" (click)="$event.stopPropagation(); toggleAllIssueSellerTypes()">
                      <input type="checkbox" [checked]="isAllIssueSellerTypeSelected" (click)="$event.stopPropagation()"
                        (change)="toggleAllIssueSellerTypes()" />
                      <span>Select All</span>
                    </label>
                    <label class="wa-multi-option" *ngFor="let opt of filteredIssueSellerTypeOptions"
                      (click)="$event.stopPropagation(); toggleIssueSellerType(opt)">
                      <input type="checkbox" [checked]="isIssueSellerTypeSelected(opt)"
                        (click)="$event.stopPropagation()" (change)="toggleIssueSellerType(opt)" />
                      <span>{{ opt }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Issue / Grantha — Advertisement department -->
            <div class="wa-form-group" *ngIf="isAdvtDept">
              <label class="wa-label"><i class="fa-solid fa-newspaper"></i> Issue / Grantha</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="advtCategoryDropdownOpen = !advtCategoryDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.issueName">{{ formData.issueName || 'Select Issue /
                    Grantha' }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="advtCategoryDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="advtCategoryDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="advtCategorySearch"
                      placeholder="Search..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <div class="wa-book-option" (click)="selectAdvtCategory('')">Select Issue / Grantha</div>
                    <div class="wa-book-option" *ngFor="let issue of filteredAdvtCategories"
                      (click)="selectAdvtCategory(issue.category)">{{ issue.category }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Issue Dates — Advertisement department -->
            <div class="wa-form-group" *ngIf="isAdvtDept && getMagIssueDatesandAdvtNames.length > 0">
              <label class="wa-label"><i class="fa-solid fa-calendar-days"></i> Issue Dates</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="issueDateDropdownOpen = !issueDateDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.issueDates.length">{{ selectedIssueDateLabel }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="issueDateDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="issueDateDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="issueDateSearch"
                      placeholder="Search dates..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" *ngFor="let item of filteredIssueDates"
                      (click)="$event.stopPropagation(); toggleIssueDate(item)">
                      <input type="checkbox" [checked]="isIssueDateSelected(item)" (click)="$event.stopPropagation()"
                        (change)="toggleIssueDate(item)" />
                      <span>{{ item.issueDate | date:'dd-MM-yyyy' }} — {{ item.issueName }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Issue / Grantha — Issue Seller department -->
            <div class="wa-form-group" *ngIf="isIssueSellerDept">
              <label class="wa-label"><i class="fa-solid fa-newspaper"></i> Issue / Grantha</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="issueSellerIssueDropdownOpen = !issueSellerIssueDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.issueSellerIssueName">{{ formData.issueSellerIssueName ||
                    'Select Issue / Grantha' }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="issueSellerIssueDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="issueSellerIssueDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="issueSellerIssueSearch"
                      placeholder="Search..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <div class="wa-book-option" (click)="selectIssueSellerIssue('')">Select Issue / Grantha</div>
                    <div class="wa-book-option" *ngFor="let issue of filteredIssueSellerIssues"
                      (click)="selectIssueSellerIssue(issue.category)">{{ issue.category }}</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Issue Dates — Issue Seller department -->
            <div class="wa-form-group" *ngIf="isIssueSellerDept && getMagIssueDatesandNames?.length > 0">
              <label class="wa-label"><i class="fa-solid fa-calendar-days"></i> Issue Dates</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger"
                  (click)="issueSellerIssueDateDropdownOpen = !issueSellerIssueDateDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.issueSellerIssueDateIds.length">{{
                    selectedIssueSellerDateLabel }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="issueSellerIssueDateDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="issueSellerIssueDateDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="issueSellerIssueDateSearch"
                      placeholder="Search dates..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" *ngFor="let item of filteredIssueSellerDates"
                      (click)="$event.stopPropagation(); toggleIssueSellerDate(item)">
                      <input type="checkbox" [checked]="isIssueSellerDateSelected(item)"
                        (click)="$event.stopPropagation()" (change)="toggleIssueSellerDate(item)" />
                      <span>{{ item.issueDate | date:'yyyy-MM-dd' }} {{ item.issueName }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Book Name multi-select — Book department -->
            <div class="wa-form-group" *ngIf="isBookDept">
              <label class="wa-label"><i class="fa-solid fa-book"></i> Book Name</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="bookDropdownOpen = !bookDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.bookNames.length">{{ selectedBookNameLabel }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="bookDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="bookDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="bookSearch"
                      placeholder="Search book..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" *ngFor="let book of filteredBookNameList"
                      (click)="$event.stopPropagation(); toggleBookName(book.book_name)">
                      <input type="checkbox" [checked]="isBookNameSelected(book.book_name)"
                        (click)="$event.stopPropagation()" (change)="toggleBookName(book.book_name)" />
                      <span>{{ book.book_name }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Subscription Type multi-select — Subscription department -->
            <div class="wa-form-group" *ngIf="isSubscriptionDept">
              <label class="wa-label"><i class="fa-solid fa-layer-group"></i> Subscription Type</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="subscriptionTypeDropdownOpen = !subscriptionTypeDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.subscriptionTypeIds.length">{{
                    selectedSubscriptionTypeLabel }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="subscriptionTypeDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="subscriptionTypeDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="subscriptionTypeSearch"
                      placeholder="Search type..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" *ngFor="let type of filteredSubscriptionTypes"
                      (click)="$event.stopPropagation(); toggleSubscriptionType(type.subtype)">
                      <input type="checkbox" [checked]="isSubscriptionTypeSelected(type.subtype)"
                        (click)="$event.stopPropagation()" (change)="toggleSubscriptionType(type.subtype)" />
                      <span>{{ type.subtype }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Delivery Mode multi-select — Subscription department -->
            <div class="wa-form-group" *ngIf="isSubscriptionDept">
              <label class="wa-label"><i class="fa-solid fa-truck"></i> Delivery Mode</label>
              <div class="wa-book-dropdown" (click)="$event.stopPropagation()">
                <div class="wa-book-trigger" (click)="deliveryModeDropdownOpen = !deliveryModeDropdownOpen">
                  <span [class.wa-book-placeholder]="!formData.deliveryModeIds.length">{{ selectedDeliveryModeLabel
                    }}</span>
                  <i class="fa-solid fa-chevron-down" [class.wa-book-open]="deliveryModeDropdownOpen"></i>
                </div>
                <div class="wa-book-panel" *ngIf="deliveryModeDropdownOpen">
                  <div class="wa-book-search-wrap"><i class="fa-solid fa-magnifying-glass"></i>
                    <input class="wa-book-search-input" type="text" [(ngModel)]="deliveryModeSearch"
                      placeholder="Search mode..." autofocus />
                  </div>
                  <div class="wa-book-options">
                    <label class="wa-multi-option" *ngFor="let mode of filteredDeliveryModes"
                      (click)="$event.stopPropagation(); toggleDeliveryMode(mode.delivery_mode)">
                      <input type="checkbox" [checked]="isDeliveryModeSelected(mode.delivery_mode)"
                        (click)="$event.stopPropagation()" (change)="toggleDeliveryMode(mode.delivery_mode)" />
                      <span>{{ mode.delivery_mode }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-globe"></i> Country
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.countryId" (change)="onCountryChange()">
                  <option value="">Select Country</option>
                  <option *ngFor="let country of countryList" [value]="country.country_id">{{ country.country_name }}
                  </option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-location-dot"></i> State
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.stateId" (change)="onStateChange()">
                  <option value="">Select State</option>
                  <option *ngFor="let state of stateList" [value]="state.id">{{ state.name }}</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-map"></i> District
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.districtId" (change)="onDistrictChange()">
                  <option value="">Select District</option>
                  <option *ngFor="let district of districtList" [value]="district.id">{{ district.name }}</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <div class="wa-form-group">
              <label class="wa-label">
                <i class="fa-solid fa-city"></i> Taluka
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.talukaId">
                  <option value="">Select Taluka</option>
                  <option *ngFor="let taluka of talukaList" [value]="taluka.id">{{ taluka.name }}</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <div class="wa-form-group" *ngIf="!isSubscriptionDept">
              <label class="wa-label">
                <i class="fa-solid fa-circle-dot"></i> Status
              </label>
              <div class="wa-select-wrapper">
                <select class="wa-select" [(ngModel)]="formData.status">
                  <option value="">Select Status</option>
                  <option value="ACTIVE">Active</option>
                  <option value="DEACTIVE">Deactive</option>
                </select>
                <i class="fa-solid fa-chevron-down wa-select-arrow"></i>
              </div>
            </div>

            <!-- Issue Date range — visible only for Subscription department -->
            <div class="wa-form-group" *ngIf="isSubscriptionDept">
              <label class="wa-label">
                <i class="fa-solid fa-calendar-day"></i> Issue Date From
              </label>
              <input type="date" class="wa-date-input" [(ngModel)]="formData.fromDate" [max]="formData.toDate || ''" />
            </div>

            <div class="wa-form-group" *ngIf="isSubscriptionDept">
              <label class="wa-label">
                <i class="fa-solid fa-calendar-check"></i> Issue Date To
              </label>
              <input type="date" class="wa-date-input" [(ngModel)]="formData.toDate" [min]="formData.fromDate || ''" />
            </div>

          </div>

          <div class="wa-btn-section">
            <button class="wa-next-btn" (click)="nextStep()" [disabled]="isLoadingCustomers">
              <span *ngIf="!isLoadingCustomers">
                Load Customers &amp; Next <i class="fa-solid fa-arrow-right"></i>
              </span>
              <span *ngIf="isLoadingCustomers">
                <i class="fa-solid fa-spinner fa-spin"></i> Loading customers…
              </span>
            </button>
          </div>

          <!-- Customer Summary (shown after clicking Next) -->
          <div class="wa-customer-summary" *ngIf="showCustomerSummary">
            <div class="wa-summary-header">
              <div class="wa-summary-title">
                <i class="fa-solid fa-users"></i>
                Selected Customers
                <span class="wa-summary-badge">{{ selectedCustomers.length }}</span>
              </div>
              <button class="wa-back-btn" type="button" (click)="showCustomerSummary = false">
                <i class="fa-solid fa-arrow-left"></i> Back
              </button>
            </div>

            <!-- Search bar -->
            <div class="wa-search-bar">
              <i class="fa-solid fa-magnifying-glass wa-search-icon"></i>
              <input class="wa-search-input" type="text" [(ngModel)]="customerSearch" (ngModelChange)="customerPage = 1"
                placeholder="Search by name or mobile…" />
              <button class="wa-search-clear" *ngIf="customerSearch" (click)="customerSearch = ''; customerPage = 1"
                title="Clear">
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>

            <!-- No results -->
            <div class="wa-no-results" *ngIf="filteredCustomers.length === 0 && customerSearch">
              <i class="fa-solid fa-user-slash"></i>
              No customers match &ldquo;{{ customerSearch }}&rdquo;
            </div>

            <div class="wa-summary-table-wrapper" *ngIf="filteredCustomers.length > 0">
              <table class="wa-summary-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Customer Name</th>
                    <th>Country</th>
                    <th>State</th>
                    <th>District</th>
                    <th>Taluka</th>
                    <th *ngIf="isSubscriptionDept">Sub. Type</th>
                    <th *ngIf="isSubscriptionDept">Delivery Mode</th>
                    <th *ngIf="isBookDept">Book Name</th>
                    <th *ngIf="isAdvtDept || isIssueSellerDept">Issue Name</th>
                    <th *ngIf="isRepresentativeDept">Representative Type</th>
                    <th>Mobile No.</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let customer of pagedCustomers; let i = index">
                    <td class="wa-sr">{{ (customerPage - 1) * customerPageSize + i + 1 }}</td>
                    <td class="wa-td-name">
                      <i class="fa-solid fa-circle-user wa-td-avatar"></i>
                      {{ customer.name }}
                    </td>
                    <td class="wa-td-location">{{ customer.country || '—' }}</td>
                    <td class="wa-td-location">{{ customer.state || '—' }}</td>
                    <td class="wa-td-location">{{ customer.district || '—' }}</td>
                    <td class="wa-td-location">{{ customer.taluka || '—' }}</td>
                    <td *ngIf="isSubscriptionDept" class="wa-td-location">{{ customer.subtype || '—' }}</td>
                    <td *ngIf="isSubscriptionDept" class="wa-td-location">{{ customer.delivery_mode || '—' }}</td>
                    <td *ngIf="isBookDept" class="wa-td-location">{{ customer.book_name || '—' }}</td>
                    <td *ngIf="isAdvtDept || isIssueSellerDept" class="wa-td-location">{{ customer.issueName ||
                      customer.issue_name || '—' }}
                    </td>
                    <td *ngIf="isRepresentativeDept" class="wa-td-location">{{ customer.issue_seller_type ||
                      customer.issueSellerType || '—' }}</td>
                    <td class="wa-td-mobile">
                      <i class="fa-solid fa-phone"></i> {{ customer.mobile }}
                    </td>
                    <td class="wa-td-action">
                      <button class="wa-row-remove-btn" type="button" title="Remove" (click)="removeCustomer(customer)">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Pagination -->
            <div class="wa-pagination" *ngIf="totalPages > 1">
              <button class="wa-page-btn" (click)="customerPage = customerPage - 1" [disabled]="customerPage === 1">
                <i class="fa-solid fa-chevron-left"></i>
              </button>

              <span class="wa-page-info">
                Page <strong>{{ customerPage }}</strong> of <strong>{{ totalPages }}</strong>
              </span>

              <button class="wa-page-btn" (click)="customerPage = customerPage + 1"
                [disabled]="customerPage === totalPages">
                <i class="fa-solid fa-chevron-right"></i>
              </button>
            </div>

            <div class="wa-summary-send-row">
              <span class="wa-summary-total">
                <i class="fa-solid fa-paper-plane"></i>
                Message will be sent to <strong>{{ selectedCustomers.length }}</strong> customer(s)
              </span>
              <button class="wa-send-btn" (click)="sendWhatsappMessage()" [disabled]="sendReport.isSending">
                <span *ngIf="!sendReport.isSending">
                  <i class="fa-brands fa-whatsapp"></i> Send WhatsApp Message
                </span>
                <span *ngIf="sendReport.isSending">
                  <i class="fa-solid fa-spinner fa-spin"></i> Sending…
                </span>
              </button>
            </div>

            <!-- Send Report — shown after all messages are processed -->
            <div class="wa-send-report" *ngIf="sendReport.isComplete">

              <div class="wa-report-header">
                <i class="fa-solid fa-circle-check"></i> Send Complete
              </div>

              <div class="wa-report-stats">
                <div class="wa-report-stat wa-stat-sent">
                  <i class="fa-solid fa-check-circle"></i>
                  <span class="wa-stat-count">{{ sendReport.sent.length }}</span>
                  <span class="wa-stat-label">Sent</span>
                </div>
                <div class="wa-report-stat wa-stat-failed">
                  <i class="fa-solid fa-times-circle"></i>
                  <span class="wa-stat-count">{{ sendReport.failed.length }}</span>
                  <span class="wa-stat-label">Failed</span>
                </div>
              </div>

              <button class="wa-download-btn" (click)="downloadSendReport()">
                <i class="fa-solid fa-file-excel"></i>
                Download Excel Report
              </button>

            </div>
          </div>

        </div>

      </div>
    </mat-tab>

    <mat-tab label="Manage Admins">
      <div class="cancel-subscriber mat-elevation-z4">
        <div>
          <h1 style="text-align: center; margin-top: 10px">Add New Admin</h1>
        </div>
        <form class="form" [formGroup]="addNewAdminForm" (ngSubmit)="addNewAdmin()" *ngIf="isAdminAuthorize">
          <div class="form-group">
            <label style="margin-left: 35px; margin-top: 20px" (change)="isadminexist($event)">Mobile</label>
            <input required style="width: 90%; margin-left: 35px" formControlName="adminMobile" type="number"
              class="form-control" placeholder="" />
          </div>
          <!-- form-row end.// -->

          <div class="form-group">
            <label style="margin-left: 35px">Email</label>
            <input required style="margin-left: 35px; margin-right: 45px; width: 90%" formControlName="adminEmail"
              type="email" class="form-control" placeholder="" />
          </div>

          <div class="form-group">
            <label style="margin-left: 35px">Password</label>
            <input required style="margin-left: 35px; margin-right: 45px; width: 90%" formControlName="adminPassword"
              type="text" class="form-control" placeholder=" " />
          </div>

          <div class="form-group">
            <button style="margin-left: 200px; width: 50%" [disabled]="addNewAdminForm.invalid" type="submit"
              class="btn btn-danger btn-block">
              Add
            </button>
          </div>
          <!-- form-group// -->
        </form>

        <div class="form-group" *ngIf="!isAdminAuthorize">
          <label style="
              font-weight: bold;
              font-size: large;
              margin-left: 33%;
              margin-top: 20%;
            ">
            You are not Authorize to this Section.
          </label>
        </div>
      </div>

      <div class="add-new-subscriber mat-elevation-z4">
        <form class="form" [formGroup]="addNewAdminForm" *ngIf="isAdminAuthorize">
          <div class="form-group">
            <label style="margin-left: 35px; margin-top: 20px">Mobile Number</label>
            <input required style="width: 70%; margin-left: 100px" (change)="validateAdmin($event)"
              formControlName="adminMobile" type="number" class="form-control" placeholder="" />
            <label *ngIf="!isvalidAdmin" style="color: red; font-weight: bold; margin-left: 25px">Please Validate Your
              Mobile Number.</label>
            <label *ngIf="isvalidAdmin" style="color: green; font-weight: bold; margin-left: 25px">Validated.</label>
          </div>
          <!-- form-row end.// -->

          <div *ngIf="isvalidAdmin">
            <table class="table table-striped text-center">
              <thead>
                <th>Name</th>
                <th>Mobile Number</th>
                <th>Email</th>
                <th>Action</th>
                <th>Make Super</th>
                <th>Remove Super</th>
              </thead>
              <tbody>
                <tr *ngFor="let ads of getalladmins; let i = index">
                  <td>{{ "office" + ads["id"] }}</td>
                  <td>{{ ads["mobile"] }}</td>
                  <td>{{ ads["email"] }}</td>
                  <td>
                    <button type="button" class="btn btn-danger btn-sm" (click)="removeAdmin(ads['id'])">
                      Remove
                    </button>
                  </td>
                  <td>
                    <button type="button" [disabled]="ads['issuper']" class="btn btn-success btn-sm"
                      (click)="superAdmin(ads['id'])">
                      Super
                    </button>
                  </td>
                  <td>
                    <button type="button" [disabled]="!ads['issuper']" class="btn btn-warning btn-sm"
                      (click)="removeadmin(ads['id'])">
                      Remove Super
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="form-group">
            <button *ngIf="!isvalidAdmin" style="margin-left: 200px; width: 50%" class="btn btn-danger btn-block"
              type="button">
              Validate Number
            </button>
          </div>
        </form>
        <div class="form-group" *ngIf="!isAdminAuthorize">
          <label style="
              font-weight: bold;
              font-size: large;
              margin-left: 33%;
              margin-top: 20%;
            ">
            You are not Authorize to this Section.
          </label>
        </div>
      </div>
    </mat-tab>

    <!-- <mat-tab label="Manage Magazine"> -->
    <!-- <mat-card style="margin-top: 2%;border-radius: 15px;">
        <form [formGroup]="NewMagazineForm">
          <div class="form-row">
            <mat-form-field style="width: 35%; margin-top: 10px; margin-left: 5%" appearance="outline">
              <mat-label>Magazine Name:</mat-label>
              <input matInput formControlName="mag_name" [matAutocomplete]="auto11" required />
              <mat-autocomplete autoActiveFirstOption #auto11="matAutocomplete">
                <mat-option (onSelectionChange)="selected_magName($event,option)"
                  *ngFor="let option of filteredOptions11 | async" [value]="option['mag_name']">
                  {{ option["mag_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field style="width: 35%; margin-top: 10px; margin-left: 2%" appearance="outline">
              <mat-label>Issue/Granth Category:</mat-label>
              <input matInput formControlName="ig_cat" />
            </mat-form-field>
            <div style="margin-top: 15px; margin-left: 2%;">
              <button class="btn btn-info" type="button" (click)="addmags()">Add</button>
            </div>
          </div>
          <div class="tableFixHead" style="margin-left: 5%; margin-right: 5%;">
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Magazine Name</th>
                  <th>Issue/Granth Category</th>
                  <th colspan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of magazineData; let i=index">
                  <td>{{ item['mag_name'] }}</td>
                  <td>{{ item['ig_cat'] }}</td>
                  <td colspan="2">
                    <button matTooltip="Update" class="btn-sm btn-outline-info" style="margin-right: 2%;" type="button"
                      (click)="updateItem(item, i)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button matTooltip="Remove" class="btn-sm btn-outline-danger" type="button"
                      (click)="removeItem(item, i)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <button mat-raised-button class="btn btn-primary" style="margin-left: 30%;width: 25%;" type="button"
              (click)="addNewMagazine()">Add Magazine</button>
          </div>
        </form>
      </mat-card> -->
    <!-- <div class="add-new-subscriber mat-elevation-z4"> -->

    <!-- <div style="margin-top: 20px">
          <table class="table table-striped text-center">
            <thead>
              <th>Sr.No.</th>
              <th>Magazine Name</th>
              <th>Year</th>
              <th>Print Edition Price</th>
              <th>Digital Edition Price</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr *ngFor="let magdetails of this.mag; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ magdetails["name"] }}</td>
                <td>{{ magdetails["year"] }}</td>
                <td>{{ magdetails["print"] }}</td>
                <td>{{ magdetails["digital"] }}</td>
                <td>
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    (click)="removeMag(magdetails['name'])"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->

    <!-- <div>
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">
              Change Magazine Price :
            </h1>
          </div>

          <form
            class="form"
            [formGroup]="magpriceupdate"
            (ngSubmit)="changeMagPrice()"
          >
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 20px; margin-top: 20px"
                  >Magazine Name :</label
                >
                <select
                  class="form-control"
                  style="width: 85%; margin-left: 20px"
                  placeholder="Select One"
                  formControlName="magname"
                >
                  <option
                    *ngFor="let item of magname"
                    value="{{ item['name'] }}"
                  >
                    {{ item["name"] }}
                  </option>
                </select>
              </div>

              <div class="col form-group">
                <label style="margin-left: 20px; margin-top: 20px"
                  >Magazine Edition :</label
                >
                <select
                  class="form-control"
                  style="width: 85%; margin-left: 20px"
                  placeholder="Select One"
                  formControlName="magedition"
                >
                  <option value="Print">Print</option>
                </select>
              </div>

              <div class="col form-group">
                <label style="margin-left: 20px; margin-top: 20px"
                  >Magazine Year :</label
                >
                <select
                  class="form-control"
                  style="width: 85%; margin-left: 20px"
                  placeholder="Select One"
                  formControlName="magyear"
                >
                  <option value="1">1</option>
                  <option value="3">3</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px"
                  >Magazine Price :</label
                >
                <input
                  required
                  style="width: 90%; margin-left: 35px"
                  formControlName="magamount"
                  type="number"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>

            <div class="form-group">
              <button
                style="margin-left: 200px; width: 50%"
                [disabled]="magpriceupdate.invalid"
                type="submit"
                class="btn btn-danger btn-block"
              >
                Change Price
              </button>
            </div>
          </form>
        </div> -->

    <!-- <div>
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">
              Add New Magazine
            </h1>
          </div>
          <form
            class="form"
            [formGroup]="magform"
            (ngSubmit)="AddNewMagazine()"
          >
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px"
                  >Magazine short Name :</label
                >
                <input
                  required
                  style="width: 90%; margin-left: 35px"
                  formControlName="magname"
                  type="text"
                  class="form-control"
                  placeholder=""
                />
              </div>

              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px"
                  >Magazine Full Name :</label
                >
                <input
                  required
                  style="width: 90%; margin-left: 35px"
                  formControlName="magfullname"
                  type="text"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 20px; margin-top: 20px"
                  >Magazine Edition :</label
                >
                <select
                  class="form-control"
                  style="margin-left: 20px"
                  placeholder="Select One"
                  formControlName="magedition"
                >
                  <option value="print">Print</option>
                  <option value="digital">Digital</option>
                </select>
              </div>

              <div class="col form-group">
                <label style="margin-left: 35px">Magazine Amount :</label>
                <input
                  required
                  style="margin-left: 35px; margin-right: 45px"
                  formControlName="magamount"
                  type="number"
                  class="form-control"
                  placeholder=""
                />
              </div>
            </div>


            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px">Year : </label>
                <input
                  style="margin-left: 35px; margin-right: 45px; width: 90%"
                  formControlName="magyear"
                  type="number"
                  class="form-control"
                  placeholder=" "
                />
              </div>

              <div class="col form-group">
                <label style="margin-left: 35px"
                  >Want to display on Application :
                </label>
                <select
                  class="form-control"
                  style="margin-left: 35px; margin-right: 45px; width: 90%"
                  class="form-control"
                  placeholder="Select One"
                  formControlName="magapp"
                >
                  <option value="Y">Yes</option>
                  <option value="N">No</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label style="margin-left: 35px">Magazine description : </label>
              <input
                style="margin-left: 35px; margin-right: 45px; width: 90%"
                formControlName="magdesc"
                type="text"
                class="form-control"
                placeholder=" "
              />
            </div>
            <div class="form-group">
              <button
                style="margin-left: 200px; width: 50%"
                [disabled]="magform.invalid"
                type="submit"
                class="btn btn-danger btn-block"
              >
                Add New Magazine
              </button>
            </div>
          </form>
        </div> -->
    <!-- </div> -->
    <!-- </mat-tab> -->

    <mat-tab label="Manage Issue Date & Size">
      <mat-card style="margin-top: 2%;border-radius: 15px;">
        <form [formGroup]="NewMagazineForm">
          <div class="form-row">
            <mat-form-field style="width: 35%; margin-top: 10px; margin-left: 5%" appearance="outline">
              <mat-label>Magazine Name:</mat-label>
              <input matInput formControlName="mag_name" [matAutocomplete]="auto11" required />
              <mat-autocomplete autoActiveFirstOption #auto11="matAutocomplete">
                <mat-option (onSelectionChange)="selected_magName($event,option)"
                  *ngFor="let option of filteredOptions11 | async" [value]="option['mag_name']">
                  {{ option["mag_name"] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
            <!--<mat-form-field style="width: 35%; margin-top: 10px; margin-left: 5%" appearance="outline">
                    <mat-label>Magazine Name:</mat-label>
                    <input matInput formControlName="mag_name" />
                  </mat-form-field> -->
            <mat-form-field style="width: 35%; margin-top: 10px; margin-left: 2%" appearance="outline">
              <mat-label>Issue/Granth Category:</mat-label>
              <input matInput formControlName="ig_cat" />
            </mat-form-field>
            <div style="margin-top: 15px; margin-left: 2%;">
              <button class="btn btn-info" type="button" (click)="addmags()">Add</button>
            </div>
          </div>
          <div class="tableFixHead" style="margin-left: 5%; margin-right: 5%;">
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>Magazine Name</th>
                  <th>Issue/Granth Category</th>
                  <th colspan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of magazineData; let i=index">
                  <td>{{ item['mag_name'] }}</td>
                  <td>{{ item['ig_cat'] }}</td>
                  <td colspan="2">
                    <button matTooltip="Update" mat-raised-button class="btn-sm btn-outline-info"
                      style="margin-right: 2%;" type="button" (click)="updateItem(item, i)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button matTooltip="Remove" mat-raised-button class="btn-sm btn-outline-danger" type="button"
                      (click)="removeItem(item, i)">
                      <mat-icon>close</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="form-group">
            <button mat-raised-button class="btn btn-primary" style="margin-left: 30%;width: 25%;" type="button"
              (click)="addNewMagazine()">Add Magazine</button>
          </div>
        </form>
      </mat-card>

      <!-- <mat-card class="IssueGM" style="margin-top: 20px">
        <mat-card-title style="text-align: center">Add Issues & Category</mat-card-title>
        <div style="margin-top: 20px">
          <form class="form" [formGroup]="addIssueGranthaForm" (ngSubmit)="addIssueGrantha()" *ngIf="isAdminAuthorize">
            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 40%; margin-top: 10px; margin-left: 45px"
                appearance="outline">
                <mat-label>Issue/Grantha Name:</mat-label>
                <input matInput formControlName="igcategory" required />
              </mat-form-field>
              <mat-form-field class="example-full-width" style="margin-left: 10px; width: 40%; margin-top: 10px"
                appearance="outline">
                <mat-label>Issue/Grantha Category :</mat-label>
                <input matInput formControlName="igsubcategory" required />
              </mat-form-field>
            </div>
            
            <div class="form-group">
              <button style="margin-left: 200px; width: 50%" [disabled]="
                  addIssueGranthaForm.invalid && this.newDateArray.lenth != 0
                " type="submit" class="btn btn-danger btn-block">
                Add Issue/Grantha
              </button>
            </div>
          </form>
        </div>
      </mat-card> -->

      <!-- <mat-tab label="Manage Advt. Sizes"> -->
      <mat-card style="margin-top: 20px">
        <mat-card-title style="text-align: center">Add Advt Sizes</mat-card-title>
        <div style="margin-top: 20px">
          <form class="form" [formGroup]="advtSizesForm" (ngSubmit)="save_advtSizes()">
            <div class="form-row">
              <mat-form-field style="margin-left: 45px; margin-top: 10px; width: 40%" appearance="outline">
                <mat-label>Issue/Grantha Category : </mat-label>
                <mat-select (selectionChange)="getAdvtCategory($event)" required>
                  <mat-option *ngFor="let item of advtCategorylist" value="{{ item['category'] }}">
                    {{ item["category"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 20px; margin-top: 10px; width: 40%" class="example-full-width"
                appearance="outline">
                <mat-label>Advt. Sizes :</mat-label>
                <input type="text" formControlName="advt_size_name" matInput required />
              </mat-form-field>
            </div>

            <div class="form-group">
              <button [disabled]="advtSizesForm.invalid" style="margin-left: 25%; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add Advt. Sizes
              </button>
            </div>
          </form>
        </div>
        <div class="tableFixHead">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Issue/Granth Category</th>
                <th>Advt. Size</th>
                <th colspan="2">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FilteredadvtsizesData; let i=index">
                <td>{{ i+1 }}</td>
                <td>{{ item['category'] }}</td>
                <td>{{ item['Advt_size'] }}</td>
                <td><button type="button" matTooltip="Update" mat-raised-button class="btn-sm btn-outline-info"
                    (click)="updateAdvtSize(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" matTooltip="Remove" mat-raised-button class="btn-sm btn-outline-danger"
                    (click)="removeAdvtSize(item)">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </mat-card>

      <mat-card style="margin-top: 20px">
        <mat-card-title style="text-align: center">Add Issue Dates</mat-card-title>
        <div style="margin-top: 20px">
          <form class="form" [formGroup]="IssueDates" (ngSubmit)="save_issue_dates()">
            <div class="form-row">
              <mat-form-field style="margin-left: 45px; margin-top: 20px; width: 25%" appearance="outline">
                <mat-label>Issue/Grantha Category : </mat-label>
                <mat-select (selectionChange)="getAdvtCategory1($event)" required>
                  <mat-option *ngFor="let item of advtCategorylist" value="{{ item['category'] }}">
                    {{ item["category"] }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; margin-top: 20px; width: 25%" appearance="outline">
                <mat-label>Select Issue date</mat-label>
                <input matInput required formControlName="issuedate" (dateChange)="selectDateChange()"
                  [matDatepicker]="picker" />
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>

              <mat-form-field style="margin-left: 3%; margin-top: 20px; width: 25%" appearance="outline">
                <mat-label>Select Published date</mat-label>
                <input matInput required formControlName="publisheddate" [matDatepicker]="picker1" />
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 40%; margin-top: 10px; margin-left: 45px"
                appearance="outline">
                <mat-label>Issue name</mat-label>
                <input matInput formControlName="issue_name" required />
              </mat-form-field>

              <mat-form-field class="example-full-width" style="margin-left: 10px; width: 40%; margin-top: 10px"
                appearance="outline">
                <mat-label>Price</mat-label>
                <input matInput formControlName="issue_price" required />
              </mat-form-field>
            </div>
            <div class="form-row">
              <mat-form-field class="example-full-width" style="margin-left: 45px; width: 40%; margin-top: 10px"
                appearance="outline">
                <mat-label>Language</mat-label>
                <mat-select (selectionChange)="getAdvtCategory1($event)" formControlName="lang" required>
                  <mat-option *ngFor="let item of getLanguageList1" value="{{ item['Languages'] }}">
                    {{ item["Languages"] }}
                  </mat-option>
                </mat-select>
                <!-- <input matInput formControlName="lang" required /> -->
              </mat-form-field>
            </div>
            <div class="form-group">
              <label style="margin-left: 45px;">Pages</label>
              <div class="form-row">
                <mat-form-field class="example-full-width" style="margin-left: 45px; width: 20%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Black White</mat-label>
                  <input type="number" matInput formControlName="blackwhite" (change)="calcPages($event)" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 2%; width: 18%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Inside Colour</mat-label>
                  <input type="number" matInput formControlName="insidecolour" (change)="calcPages($event)" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 2%; width: 18%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Cover</mat-label>
                  <input type="number" matInput formControlName="cover" (change)="calcPages($event)" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 2%; width: 18%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Total Pages</mat-label>
                  <input type="number" matInput formControlName="totalpages" readonly />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label style="margin-left: 45px;">Paper</label>
              <div class="form-row">
                <mat-form-field class="example-full-width" style="margin-left: 45px; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Maflitho</mat-label>
                  <input matInput formControlName="maflitho" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>LWC</mat-label>
                  <input matInput formControlName="lwc" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label>Art Paper</mat-label>
                  <input matInput formControlName="artpaper" />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label style="margin-left: 45px;">Paper Reams</label>
              <div class="form-row">
                <mat-form-field class="example-full-width" style="margin-left: 45px; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label></mat-label>
                  <input matInput formControlName="paperreams1" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label></mat-label>
                  <input matInput formControlName="paperreams2" />
                </mat-form-field>
                <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                  appearance="outline">
                  <mat-label></mat-label>
                  <input matInput formControlName="paperreams3" />
                </mat-form-field>
              </div>
            </div>
            <div class="form-row">
              <mat-form-field class="example-full-width" style="margin-left: 45px; width: 25%; margin-top: 10px"
                appearance="outline">
                <mat-label>Issue Size</mat-label>
                <input matInput formControlName="issuesize" />
              </mat-form-field>
              <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                appearance="outline">
                <mat-label>Per Copy Weight</mat-label>
                <input matInput formControlName="percopyweight" />
              </mat-form-field>
              <mat-form-field class="example-full-width" style="margin-left: 3%; width: 25%; margin-top: 10px"
                appearance="outline">
                <mat-label>Printed Copies</mat-label>
                <input type="number" matInput formControlName="prntdcopies" />
              </mat-form-field>
            </div>
            <div class="form-group">
              <mat-form-field appearance="outline" style="margin-left: 45px; width: 25%;">
                <mat-label>RNI Releated</mat-label>
                <mat-select formControlName="rnireleated" required>
                  <mat-option value="yes">Yes</mat-option>
                  <mat-option value="no">No</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="form-group">
              <button [disabled]="IssueDates.invalid" style="margin-left: 27%; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add New Dates
              </button>
            </div>
          </form>
        </div>
      </mat-card>

      <mat-card>
        <div class="tableFixHead" style="margin-left: 5%; margin-right: 5%;">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Sr. No.</th>
                <th>Issue Name</th>
                <th>Issue Category</th>
                <th>Issue Date</th>
                <th>Published Date</th>
                <th>Price</th>
                <th>Language</th>
                <th colspan="2">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of FilteredissueDatesData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item['issueName'] }}</td>
                <td>{{ item['advt_category'] }}</td>
                <td>{{ item['issueDate'] | date: "dd-MM-yyy" }}</td>
                <td>{{ item['PublishedDate'] | date: "dd-MM-yyy" }}</td>
                <td>{{ item['price'] }}</td>
                <td>{{ item['lang'] }}</td>
                <td colspan="2">
                  <button matTooltip="Update" mat-raised-button class="btn-sm btn-outline-info"
                    style="margin-right: 2%;" type="button" (click)="updateIssueDates(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Remove" mat-raised-button class="btn-sm btn-outline-danger" type="button"
                    (click)="removeIssueDates(item)">
                    <mat-icon>close</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important" id="excel-table">
          <div style="margin-top: 20px" class="tableFixHead">
            <table class="table table-striped text-center">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>Category</th>
                  <th>प्रकाशनाच्या तारखा</th>
                  <th colspan="2">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let advt of this.Filteredadvt_mag_name_details; let i = index">
                  <td>{{ i + 1 }}</td>
                  <td>{{ advt["category"] }}</td>
                  <td>
                    <mat-form-field style="margin-left: 3%">
                      <mat-label>Publishig Dates</mat-label>
                      <mat-select name="issue">
                        <mat-option *ngFor="
                            let issue of advt['publishing_date'];
                            let newindex = index
                          " [value]="issue">
                          {{ issue | date: "dd-MM-yyy" }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </td>

                  <td>
                    <button type="button" matTooltip="Update" mat-raised-button class="btn-sm btn-outline-info"
                      (click)="manageAdvtDates(advt)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button *ngIf="advt['is_active'] == 'Y'" type="button" matTooltip="Inactivate" matTooltip="Inactive"
                      mat-raised-button class="btn-sm btn-outline-danger" (click)="remove_mag_advt(advt)">
                      <mat-icon>close</mat-icon>
                    </button>
                    <button *ngIf="advt['is_active'] == 'N'" type="button" matTooltip="Activate" mat-raised-button
                      class="btn-sm btn-outline-success" (click)="make_it_activate(advt)">
                      <mat-icon>done</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div> -->
      </mat-card>
    </mat-tab>

    <!-- ===== CURSOR TRACKER (place just inside your mat-tab body) ===== -->
    <div id="cursor-glow"></div>
    <div id="cursor-dot"></div>
    <div id="cursor-ring"></div>
    <div id="cursor-label">x: 0 &nbsp; y: 0</div>

    <mat-tab label="Location Master">
      <div class="lm-tab-wrapper" (mousemove)="onMouseMove($event)">

        <!-- TAB HEADER BANNER -->
        <div class="lm-banner">
          <div class="lm-banner-icon"><mat-icon>public</mat-icon></div>
          <div>
            <h2 class="lm-banner-title">Location Master</h2>
            <p class="lm-banner-sub">MANAGE · COUNTRY · STATE · DISTRICT · TALUKA</p>
          </div>
        </div>

        <mat-accordion class="lm-accordion" style="margin: 20px; display: block;">

          <!-- ==================== COUNTRY ==================== -->
          <mat-expansion-panel class="lm-panel">
            <mat-expansion-panel-header class="lm-panel-header">
              <mat-panel-title class="lm-panel-title">
                <span class="lm-hicon"><mat-icon>public</mat-icon></span>
                Add Country
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="lm-panel-body">
              <form [formGroup]="addcountry">
                <div class="lm-form-grid">
                  <div class="lm-field-group">
                    <label class="lm-label">Country Name</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="country_name" placeholder="e.g. India" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Country Code</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="country_code" placeholder="e.g. IN" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Sequence ID</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="sequence_id" type="number" placeholder="1" required />
                    </mat-form-field>
                  </div>
                </div>

                <div class="lm-btn-row">
                  <button type="button" class="lm-btn-primary" (click)="addcountryfun()">
                    <mat-icon>add</mat-icon> Add Country
                  </button>
                  <button *ngIf="updatecountry123" type="button" class="lm-btn-outline" (click)="updatecountryfun()">
                    <mat-icon>edit</mat-icon> Update
                  </button>
                </div>
              </form>

              <div class="lm-divider-label"><span>Country Records</span></div>

              <div class="lm-table-wrap">
                <table class="lm-table">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>Country Name</th>
                      <th>Country Code</th>
                      <th>Sequence</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getcountry || []; let i = index">
                      <td><span class="lm-sr-badge">{{ i + 1 }}</span></td>
                      <td>{{ item['country_name'] }}</td>
                      <td><span class="lm-code-chip">{{ item['country_code'] }}</span></td>
                      <td>{{ item['sequence_id'] }}</td>
                      <td>
                        <button type="button" class="lm-action-btn" matTooltip="Update" (click)="updatecountry(item)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="lm-action-btn lm-action-delete" matTooltip="Delete"
                          (click)="deletecountry(item)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ==================== STATE ==================== -->
          <mat-expansion-panel class="lm-panel">
            <mat-expansion-panel-header class="lm-panel-header">
              <mat-panel-title class="lm-panel-title">
                <span class="lm-hicon"><mat-icon>map</mat-icon></span>
                Add States
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="lm-panel-body">
              <form [formGroup]="StateMaster" (ngSubmit)="save_state()">
                <div class="lm-form-grid">
                  <div class="lm-field-group">
                    <label class="lm-label">Select Country</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <mat-select formControlName="country_id" (selectionChange)="onCountrySelectForState()">
                        <mat-option *ngFor="let country of countries" [value]="country.country_id">
                          {{ country.country_name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">State Name</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="State_name" placeholder="" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Sequence</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="sequence_id" type="number" placeholder="1" required />
                    </mat-form-field>
                  </div>
                </div>

                <div class="lm-btn-row">
                  <button type="submit" class="lm-btn-primary" [disabled]="StateMaster.invalid">
                    <mat-icon>add</mat-icon> Add State
                  </button>
                </div>
              </form>

              <div class="lm-divider-label"><span>State Records</span></div>

              <div class="lm-table-wrap">
                <table class="lm-table">
                  <thead>
                    <tr>
                      <th>Sr.No.</th>
                      <th>State</th>
                      <th>Sequence</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of states; let i = index">
                      <td><span class="lm-sr-badge">{{ i + 1 }}</span></td>
                      <td>{{ item['state_name'] }}</td>
                      <td>{{ item['sequence_id'] }}</td>
                      <td><button type="button" class="lm-action-btn" matTooltip="Update"
                          (click)="updateState(item)"><mat-icon>edit</mat-icon></button><button type="button"
                          class="lm-action-btn lm-action-del" matTooltip="Remove"
                          (click)="removeState(item['state_id'])"><mat-icon>delete</mat-icon></button></td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="4">Total States : {{ state_count }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ==================== DISTRICT ==================== -->
          <mat-expansion-panel class="lm-panel">
            <mat-expansion-panel-header class="lm-panel-header">
              <mat-panel-title class="lm-panel-title">
                <span class="lm-hicon"><mat-icon>location_city</mat-icon></span>
                Add District
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="lm-panel-body">

              <!-- Filter: Select State (for form) -->
              <div class="lm-filter-row">
                <div class="lm-field-group">
                  <label class="lm-label">Select State</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getState($event)">
                      <mat-option *ngFor="let item of states" [value]="item['state_id']">
                        {{ item['state_name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <form class="form" [formGroup]="CityMaster" (ngSubmit)="save_city()">
                <div class="lm-form-grid">
                  <div class="lm-field-group">
                    <label class="lm-label">City Name</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="city_name" placeholder="e.g. Pune" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Sequence</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="sequence_id" type="number" placeholder="1" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Prant Name</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <mat-select formControlName="prant_name" required>
                        <mat-option *ngFor="let item of prantData" [value]="item['id']">
                          {{ item['prant_name'] }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>

                <div class="lm-btn-row">
                  <button type="submit" class="lm-btn-primary" [disabled]="CityMaster.invalid">
                    <mat-icon>add</mat-icon> Add New City
                  </button>
                </div>
              </form>

              <div class="lm-divider-label"><span>District Records</span></div>

              <!-- Filter: Select State (for table) -->
              <div class="lm-filter-row">
                <div class="lm-field-group">
                  <label class="lm-label">Filter by State</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getChangeState($event)">
                      <mat-option *ngFor="let item of states" [value]="item['state_id']">
                        {{ item['state_name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="lm-table-wrap">
                <table class="lm-table">
                  <thead>
                    <tr>
                      <th>Sr.No.</th>
                      <th>City</th>
                      <th>Sequence</th>
                      <th>Prant</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getAllCities; let i = index">
                      <td><span class="lm-sr-badge">{{ i + 1 }}</span></td>
                      <td>{{ item['name'] }}</td>
                      <td>{{ item['sequence_id'] }}</td>
                      <td>{{ item['prant_name'] }}</td>
                      <td>
                        <button type="button" class="lm-action-btn" matTooltip="Update" (click)="updateDistrict(item)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="lm-action-btn lm-action-del" matTooltip="Remove"
                          (click)="removeCity(item['id'])">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5">Total : {{ city_count }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </mat-expansion-panel>

          <!-- ==================== TALUKA ==================== -->
          <mat-expansion-panel class="lm-panel">
            <mat-expansion-panel-header class="lm-panel-header">
              <mat-panel-title class="lm-panel-title">
                <span class="lm-hicon"><mat-icon>location_on</mat-icon></span>
                Add Talukas
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="lm-panel-body">

              <!-- Filters (for form) -->
              <div class="lm-filter-row">
                <div class="lm-field-group">
                  <label class="lm-label">Select State</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getChangeState($event)">
                      <mat-option *ngFor="let item of states" [value]="item['state_id']">
                        {{ item['state_name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="lm-field-group">
                  <label class="lm-label">Select District</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getDistrict($event)">
                      <mat-option *ngFor="let item of getAllCities" [value]="item['id']">
                        {{ item['name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <form class="form" [formGroup]="TalukaMaster" (ngSubmit)="save_taluka()">
                <div class="lm-form-grid">
                  <div class="lm-field-group">
                    <label class="lm-label">Taluka Name</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="taluka_name" placeholder="" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Sequence</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput formControlName="sequence_id" type="number" placeholder="" required />
                    </mat-form-field>
                  </div>
                  <div class="lm-field-group">
                    <label class="lm-label">Pincode</label>
                    <mat-form-field class="lm-field" appearance="outline">
                      <input matInput [value]="TalukaMaster.get('pincode')?.value || ''"
                        (input)="onPincodeInput($event)" placeholder="411001" maxlength="6" />
                    </mat-form-field>
                  </div>
                </div>

                <div class="lm-btn-row">
                  <button type="submit" class="lm-btn-primary">
                    <mat-icon>add</mat-icon> Add New Taluka
                  </button>
                </div>
              </form>

              <div class="lm-divider-label"><span>Taluka Records</span></div>

              <!-- Filters (for table) -->
              <div class="lm-filter-row">
                <div class="lm-field-group">
                  <label class="lm-label">Filter by State</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getChangeState($event)">
                      <mat-option *ngFor="let item of states" [value]="item['state_id']">
                        {{ item['state_name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="lm-field-group">
                  <label class="lm-label">Filter by District</label>
                  <mat-form-field class="lm-field-sm" appearance="outline">
                    <mat-select (selectionChange)="getChangeDistrict($event)">
                      <mat-option *ngFor="let item of getAllCities" [value]="item['id']">
                        {{ item['name'] }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>

              <div class="lm-table-wrap">
                <table class="lm-table">
                  <thead>
                    <tr>
                      <th>Sr.No.</th>
                      <th>Taluka</th>
                      <th>Pincode</th>
                      <th>Sequence</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getAllTalukas; let i = index">
                      <td><span class="lm-sr-badge">{{ i + 1 }}</span></td>
                      <td>{{ item['taluka_name'] }}</td>
                      <td>{{ item['pincode'] && item['pincode'] != 0 ? item['pincode'] : '—' }}</td>
                      <td>{{ item['sequence_id'] }}</td>
                      <td>
                        <button type="button" class="lm-action-btn" matTooltip="Update" (click)="updateTaluka(item)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button type="button" class="lm-action-btn lm-action-del" matTooltip="Remove"
                          (click)="removeTaluka(item['taluka_id'])">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colspan="5">Total : {{ taluka_count }}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>
          </mat-expansion-panel>

        </mat-accordion>
      </div>
    </mat-tab>

    <mat-tab label="Manage Prant">
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important">
        <div style="margin-top: 20px">
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">Add New Prant</h1>
          </div>

          <form class="form" [formGroup]="prantMaster" (ngSubmit)="save_prant()">
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px">Prant Name :</label>
                <input required style="width: 90%; margin-left: 35px" formControlName="prant_name" class="form-control"
                  type="text" placeholder="" />
              </div>
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px">Sequence ID :</label>
                <input style="width: 90%; margin-left: 35px" formControlName="sequence_id" class="form-control"
                  type="number" placeholder="e.g. 1" />
              </div>
            </div>

            <div class="form-group">
              <button [disabled]="prantMaster.invalid" style="margin-left: 27%; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add New Prant
              </button>
            </div>
          </form>
        </div>

        <div class="tableFixHead">
          <table class="table table-striped text-center table-fixed">
            <thead>
              <th>Sr.No.</th>
              <th>Prant Name</th>
              <th>Sequence</th> <!-- ← fixed duplicate header -->
              <th>Action</th>
            </thead>
            <tbody>
              <tr *ngFor="let item of prantData; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item['prant_name'] }}</td>
                <td>{{ item['sequence_id'] }}</td> <!-- ← new column -->
                <td>
                  <button type="button" class="btn-sm btn-outline-info" matTooltip="Update" (click)="updatePrant(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button type="button" style="margin-left: 5%;" class="btn-outline-danger btn-sm" matTooltip="Remove"
                    (click)="removePrant(item['id'])">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Representative">
      <mat-card class="rep-card">
        <form [formGroup]="addform" (ngSubmit)="addRepresentativeForm()">

          <!-- ── Representative Name ─────────────────────── -->
          <div class="rep-section-title">Representative Name</div>
          <div class="rep-row rep-row--name">

            <mat-form-field appearance="outline">
              <mat-label>Representative Name (मराठी)</mat-label>
              <input matInput type="text" formControlName="issuesellername" [matAutocomplete]="autorep"
                (input)="translateToEnglishRep('issuesellername','issuesellername_en')" />
              <mat-autocomplete #autorep="matAutocomplete" autoActiveFirstOption>
                <mat-option *ngFor="let option of filteredOptions4 | async" [value]="option['name']"
                  (onSelectionChange)="selected_rep_name($event, option)">
                  {{ option['name'] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Mobile No (Search)</mat-label>
              <input matInput type="number" formControlName="mnumber_search" placeholder="Search by mobile"
                [matAutocomplete]="automob" />
              <mat-autocomplete #automob="matAutocomplete" autoActiveFirstOption>
                <mat-option *ngFor="let option of filteredOptions5 | async" [value]="option['mob_no']"
                  (onSelectionChange)="selected_rep_name($event, option)">
                  {{ option['mob_no'] }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>Representative Name (English)</mat-label>
              <input matInput type="text" formControlName="issuesellername_en" />
            </mat-form-field>

          </div>

          <!-- ── Address ────────────────────────────────────── -->
          <div class="rep-section-title">Address</div>

          <!-- Row: Address मराठी | Address English -->
          <div class="rep-row rep-row--address">
            <mat-form-field appearance="outline">
              <mat-label>Address (मराठी)</mat-label>
              <textarea matInput formControlName="address1" rows="2"
                (input)="translateToEnglishRep('address1','address1_en')"></textarea>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>Address (English)</mat-label>
              <textarea matInput formControlName="address1_en" rows="2"></textarea>
            </mat-form-field>
          </div>

          <!-- Row: Pincode | Country मराठी | Country English | State मराठी | State English -->
          <div class="rep-row rep-row--pincode">
            <mat-form-field appearance="outline">
              <mat-label>Pincode</mat-label>
              <input matInput #postalCode1 maxlength="6" formControlName="pincode" required
                (change)="getPincode1($event)" />
              <mat-hint align="end">{{ postalCode1.value.length }} / 6</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Country (मराठी)</mat-label>
              <mat-select formControlName="country" required (selectionChange)="onCountrySelect($event)">
                <mat-option *ngFor="let c of countries" [value]="c['country_name']">
                  {{ c['country_name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>Country (English)</mat-label>
              <input matInput formControlName="country_en" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>State (मराठी)</mat-label>
              <mat-select formControlName="state" required (selectionChange)="onStateSelect($event)">
                <mat-option *ngFor="let c of states" [value]="c['state_name']">
                  {{ c['state_name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>State (English)</mat-label>
              <input matInput formControlName="state_en" readonly />
            </mat-form-field>
          </div>

          <!-- Row: District मराठी | District English | Taluka मराठी | Taluka English -->
          <div class="rep-row rep-row--district">
            <mat-form-field appearance="outline">
              <mat-label>District (मराठी)</mat-label>
              <mat-select formControlName="district" required (selectionChange)="onDistrictSelect($event)">
                <mat-option *ngFor="let c of cities" [value]="c['district_name']">
                  {{ c['district_name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>District (English)</mat-label>
              <input matInput formControlName="district_en" readonly />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Taluka (मराठी)</mat-label>
              <mat-select formControlName="taluka" (selectionChange)="onTalukaSelect($event)">
                <mat-option *ngFor="let c of talukas" [value]="c['taluka_name']">
                  {{ c['taluka_name'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="rep-field--en rep-field--en-readonly">
              <mat-label>Taluka (English)</mat-label>
              <input matInput formControlName="taluka_en" readonly />
            </mat-form-field>
          </div>

          <!-- ── Contact Details ────────────────────────────── -->
          <div class="rep-section-title">Contact Details</div>

          <!-- Row: Mobile | Email | Landline | DOB -->
          <div class="rep-row rep-row--contact">
            <mat-form-field appearance="outline" [style.color]="validmobile ? null : 'red'">
              <mat-label>Mobile</mat-label>
              <span matPrefix>+91&nbsp;</span>
              <input matInput type="tel" #mobile1 maxlength="10" formControlName="mnumber"
                (change)="validateMobile($event)" />
              <span matSuffix><mat-icon>call</mat-icon></span>
              <mat-hint align="end">{{ mobile1.value.length }} / 10</mat-hint>
              <mat-error *ngIf="!validmobile">Please enter a valid 10-digit mobile no.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" [style.color]="validemail ? null : 'red'">
              <mat-label>Email</mat-label>
              <input matInput type="email" formControlName="email" placeholder="pat@example.com"
                (change)="validateEmail($event)" />
              <span matSuffix><mat-icon>email</mat-icon></span>
              <mat-error *ngIf="!validemail">Please enter a valid email address.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Landline No.</mat-label>
              <input matInput type="text" #land1 maxlength="12" formControlName="landline_no" />
              <mat-hint align="end">{{ land1.value.length }} / 12</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Date of Birth</mat-label>
              <input matInput type="date" formControlName="dob" (dateChange)="validateDob($event)" />
              <mat-error *ngIf="validdob">Please enter a valid date of birth.</mat-error>
            </mat-form-field>
          </div>

          <!-- ── Tax Details ────────────────────────────────── -->
          <div class="rep-section-title">Tax Details</div>

          <!-- Row: GST | PAN | Deposit -->
          <div class="rep-row rep-row--tax">
            <mat-form-field appearance="outline">
              <mat-label>GST No.</mat-label>
              <input matInput #gst1 maxlength="15" type="text" formControlName="gstno" />
              <mat-hint align="end">{{ gst1.value.length }} / 15</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>PAN No.</mat-label>
              <input matInput #pan1 maxlength="10" type="text" formControlName="panno" />
              <mat-hint align="end">{{ pan1.value.length }} / 10</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Deposit Amount (₹)</mat-label>
              <input matInput type="number" formControlName="depositamt" />
            </mat-form-field>
          </div>

          <!-- ── Work Period & Status ───────────────────────── -->
          <div class="rep-section-title">Work Period &amp; Status</div>
          <!-- Row: Start Date | End Date | Status -->
          <div class="rep-row rep-row--dates">
            <mat-form-field appearance="outline">
              <mat-label>Start Date</mat-label>
              <input matInput type="date" formControlName="start_date" />
              <mat-hint>Date when representative started</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>End Date (Deactivation Date)</mat-label>
              <input matInput type="date" formControlName="end_date" (change)="onEndDateChange($event)" />
              <mat-hint>Leave blank if still active</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Status</mat-label>
              <mat-select formControlName="rep_status">
                <mat-option value="active">✅ Active</mat-option>
                <mat-option value="deactive">❌ Deactive</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Row: Narration full width -->
          <div class="rep-row rep-row--narration">
            <mat-form-field appearance="outline">
              <mat-label>Narration (Reason for Deactivation)</mat-label>
              <textarea matInput formControlName="narration" rows="2"
                placeholder="e.g. Representative passed away, Contract ended, Resigned..."></textarea>
              <mat-hint>Required if End Date is filled</mat-hint>
            </mat-form-field>
          </div>

          <!-- ── Representative Type ───────────────────────── -->
          <div class="rep-section-title">Representative Type</div>
          <mat-radio-group class="rep-radio-group" formControlName="option" (change)="select($event)">
            <mat-radio-button value="agent">Agent</mat-radio-button>
            <mat-radio-button value="representative">Representative</mat-radio-button>
            <mat-radio-button value="distributor">Distributor</mat-radio-button>
            <mat-radio-button value="all">All</mat-radio-button>
          </mat-radio-group>

          <!-- Hidden fields -->
          <div style="visibility:hidden; height:0; overflow:hidden;">
            <mat-form-field appearance="outline">
              <mat-label>सप्रेम भेट</mat-label>
              <input matInput type="number" formControlName="sampremebhet" />
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Delivery Mode</mat-label>
              <mat-select formControlName="distype">
                <mat-option *ngFor="let rep of delivery_mode" [value]="rep['delivery_mode']">
                  {{ rep['delivery_mode'] }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- ── Buttons ───────────────────────────────────── -->
          <div class="rep-btn-row">
            <button *ngIf="!selected_repname" type="submit" class="rep-btn rep-btn--add" [disabled]="addform.invalid">
              + Add Representative
            </button>
            <button *ngIf="selected_repname" type="button" class="rep-btn rep-btn--update" (click)="updaterep()">
              ✎ Update Representative
            </button>
          </div>

        </form>
      </mat-card>
      <!-- ── List Table ─────────────────────────────── -->
      <mat-card class="rep-list-card">

        <!-- ── Toolbar ── -->
        <div class="rl-toolbar no-print">

          <!-- Filter Header -->
          <div class="rl-filter-header">
            <mat-icon class="filter-icon">tune</mat-icon>
            <span class="filter-label">Filters</span>
            <div class="filter-divider"></div>
          </div>

          <!-- ALL Filters in ONE single row (wraps naturally) -->
          <div class="rl-filters-wrap">

            <!-- Search -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--search">
              <mat-label>Search</mat-label>
              <input matInput [(ngModel)]="searchQuery" (input)="applyFilters()" placeholder="Name, mobile, email…" />
              <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <!-- Start Date -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>Start Date</mat-label>
              <input matInput [matDatepicker]="startDatePicker" [(ngModel)]="filterStartDate"
                (dateChange)="applyFilters()" placeholder="DD/MM/YYYY" readonly />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>

            <!-- End Date Filter -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>End Date</mat-label>
              <input matInput [matDatepicker]="endDatePicker" [(ngModel)]="filterEndDate" (dateChange)="applyFilters()"
                placeholder="Select End Date">
              <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #endDatePicker></mat-datepicker>
            </mat-form-field>


            <!-- Status -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>Status</mat-label>
              <mat-select [(value)]="statusFilter" (selectionChange)="applyFilters()">
                <mat-option value="">All Status</mat-option>
                <mat-option value="active">✅ Active</mat-option>
                <mat-option value="deactive">❌ Deactive</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Country -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>Country</mat-label>
              <mat-select [(value)]="filterCountry" (selectionChange)="onFilterCountryChange()">
                <mat-option value="">All Countries</mat-option>
                <mat-option *ngFor="let c of filterCountries" [value]="c">{{ c }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- State -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>State</mat-label>
              <mat-select [(value)]="filterState" (selectionChange)="onFilterStateChange()">
                <mat-option value="">All States</mat-option>
                <mat-option *ngFor="let s of filterStates" [value]="s">{{ s }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- District -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>District</mat-label>
              <mat-select [(value)]="filterDistrict" (selectionChange)="onFilterDistrictChange()">
                <mat-option value="">All Districts</mat-option>
                <mat-option *ngFor="let d of filterDistricts" [value]="d">{{ d }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Taluka -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>Taluka</mat-label>
              <mat-select [(value)]="filterTaluka" (selectionChange)="applyFilters()">
                <mat-option value="">All Talukas</mat-option>
                <mat-option *ngFor="let t of filterTalukas" [value]="t">{{ t }}</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- DOB From -->
            <!-- Replace DOB From and DOB To with single DOB filter -->
            <!-- Replace DOB datepicker with month dropdown -->
            <mat-form-field appearance="outline" class="rl-ff rl-ff--sm">
              <mat-label>DOB Month</mat-label>
              <mat-select [(value)]="filterDobMonth" (selectionChange)="applyFilters()">
                <mat-option value="">All Months</mat-option>
                <mat-option value="1">January</mat-option>
                <mat-option value="2">February</mat-option>
                <mat-option value="3">March</mat-option>
                <mat-option value="4">April</mat-option>
                <mat-option value="5">May</mat-option>
                <mat-option value="6">June</mat-option>
                <mat-option value="7">July</mat-option>
                <mat-option value="8">August</mat-option>
                <mat-option value="9">September</mat-option>
                <mat-option value="10">October</mat-option>
                <mat-option value="11">November</mat-option>
                <mat-option value="12">December</mat-option>
              </mat-select>
            </mat-form-field>
            <!-- Type Filter -->
            <mat-form-field appearance="outline">
              <mat-label>Type</mat-label>
              <mat-select [(ngModel)]="typeFilter" (selectionChange)="applyFilters()">
                <mat-option value="">All</mat-option>
                <mat-option value="agent">Agent</mat-option>
                <mat-option value="representative">Representative</mat-option>
                <mat-option value="distributor">Distributor</mat-option>
                <mat-option value="all">All</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Clear Button — inline with filters -->
            <button mat-flat-button class="rl-btn-clear" (click)="clearAllFilters()">
              <mat-icon>close</mat-icon> Clear
            </button>

          </div>

          <!-- Action Row -->
          <div class="rl-action-row">
            <div class="rl-result-count" *ngIf="filteredList.length >= 0">
              <mat-icon>people</mat-icon>
              <span>{{ filteredList.length }} Record<span *ngIf="filteredList.length !== 1">s</span></span>
            </div>
            <div class="rl-action-btns">
              <button class="rl-btn-print rl-btn-label" (click)="printPages()">
                <mat-icon>label</mat-icon>
                Print Address Label
              </button>
              <button class="rl-btn-print rl-btn-list" (click)="printPagesList()">
                <mat-icon>print</mat-icon>
                Print List
              </button>
              <button class="rl-btn-print rl-btn-export" (click)="exportFilteredList()">
                <mat-icon>download</mat-icon>
                Export Excel
              </button>
            </div>
          </div>
        </div>

        <!-- ── Table ── -->
        <div class="rl-table-scroll" id="repListSection1">
          <table class="rl-table">
            <thead>
              <tr>
                <th>Sr</th>
                <th>Name</th>
                <th>Address</th>
                <th>Pincode</th>
                <th>State</th>
                <th>District</th>
                <th>Taluka</th>
                <th>Mobile</th>
                <th>Email</th>
                <th>DOB</th>
                <th>GST No</th>
                <th>PAN No</th>
                <th>Deposit (₹)</th>
                <th>Type</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Status</th>
                <th>Narration</th>
                <th class="no-print">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="filteredList.length === 0">
                <td colspan="19" class="rl-empty">
                  <div class="empty-state">
                    <mat-icon class="empty-icon">inbox</mat-icon>
                    <p>No records found.</p>
                    <span>Try adjusting your filters</span>
                  </div>
                </td>
              </tr>
              <tr *ngFor="let item of filteredList; let i = index" class="rl-row">
                <td class="rl-sr">{{ i + 1 }}</td>
                <td class="rl-name">{{ item['issueSellerName'] }}</td>
                <td class="rl-long">{{ item['address'] }}</td>
                <td class="rl-pin">{{ item['pincode'] }}</td>
                <td>{{ item['state'] }}</td>
                <td>{{ item['district'] }}</td>
                <td>{{ item['taluka'] }}</td>
                <td class="rl-nowrap">{{ item['mobile_no'] }}</td>
                <td class="rl-long">{{ item['email'] }}</td>
                <td class="rl-nowrap">
                  <ng-container *ngIf="item['dateofbirth'] && item['dateofbirth'] !== '0000-00-00 00:00:00'">
                    {{ item['dateofbirth'] | date:"dd-MM-yyyy" }}
                  </ng-container>
                  <span *ngIf="!item['dateofbirth'] || item['dateofbirth'] === '0000-00-00 00:00:00'"
                    class="rl-dash">—</span>
                </td>
                <td class="rl-mono">{{ item['gst_no'] || '—' }}</td>
                <td class="rl-mono">{{ item['pan_no'] || '—' }}</td>
                <td class="rl-amount">₹{{ item['deposit_amt'] || '0' }}</td>
                <td><span class="rl-badge rl-badge--type">{{ item['issueSellerType'] }}</span></td>
                <td class="rl-nowrap">
                  <ng-container *ngIf="item['start_date'] && item['start_date'] !== '0000-00-00'">
                    {{ item['start_date'] | date:"dd-MM-yyyy" }}
                  </ng-container>
                  <span *ngIf="!item['start_date'] || item['start_date'] === '0000-00-00'" class="rl-dash">—</span>
                </td>
                <td class="rl-nowrap">
                  <ng-container *ngIf="item['end_date'] && item['end_date'] !== '0000-00-00'">
                    {{ item['end_date'] | date:"dd-MM-yyyy" }}
                  </ng-container>
                  <span *ngIf="!item['end_date'] || item['end_date'] === '0000-00-00'" class="rl-dash">—</span>
                </td>
                <td>
                  <span class="rl-badge rl-badge--active" *ngIf="getRepStatus(item) === 'active'">
                    <span class="rl-dot rl-dot--green"></span> Active
                  </span>
                  <span class="rl-badge rl-badge--inactive" *ngIf="getRepStatus(item) === 'deactive'">
                    <span class="rl-dot rl-dot--red"></span> Inactive
                  </span>
                  <span class="rl-dash" *ngIf="!getRepStatus(item)">—</span>
                </td>
                <td class="rl-long">{{ item['narration'] || '—' }}</td>
                <td class="no-print rl-action-cell">
                  <button mat-icon-button matTooltip="Edit" class="rl-btn-edit" (click)="updateRepData(item)">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button mat-icon-button matTooltip="Delete" class="rl-btn-del" (click)="deleteoldlist(item)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </mat-card>

      <!-- ── Saprem Bhet Toggle Button ── -->
      <div class="sbhet-toggle-row">
        <button class="sbhet-toggle-btn" (click)="showSbhetCard = !showSbhetCard">
          <mat-icon>{{ showSbhetCard ? 'expand_less' : 'expand_more' }}</mat-icon>
          <span>सप्रेम भेट (Subscription Tab)</span>
          <span class="sbhet-badge" *ngIf="!showSbhetCard">Click to Open</span>
          <span class="sbhet-badge sbhet-badge--open" *ngIf="showSbhetCard">Click to Close</span>
        </button>
      </div>

      <!-- ── Saprem Bhet Card — hidden by default ── -->
      <div *ngIf="showSbhetCard" class="sbhet-card-wrapper">
        <mat-card class="mt-5">
          <!-- Card Title -->
          <div class="sbhet-card-title">
            <mat-icon>card_giftcard</mat-icon>
            <span>सप्रेम भेट — Subscription Tab</span>
          </div>

          <form class="form" [formGroup]="sbhet">
            <div class="form-row">
              <mat-form-field class="example-full-width" style="width: 25%; margin-left: 7%; margin-top: 2%">
                <mat-label>Representative Name:</mat-label>
                <input #myInput matInput formControlName="id" [matAutocomplete]="issuesellername" />
                <mat-autocomplete #issuesellername="matAutocomplete">
                  <mat-option (onSelectionChange)="selected_rep_name1($event, option)"
                    *ngFor="let option of filteredOptions | async" [value]="option['name']">
                    {{ option["name"] }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>

              <mat-form-field style="margin-left: 5%; width: 25%;margin-top: 10px;" appearance="outline">
                <mat-label>Issue/grantha : </mat-label>
                <mat-select (selectionChange)="getIssues($event)" formControlName="issuename" required>
                  <mat-option *ngFor="let item of advtCategorylist" value="{{ item.category }}">
                    {{ item.category }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field style="margin-left: 5%; width: 25%;margin-top: 10px;" appearance="outline">
                <mat-label>Select date</mat-label>
                <input matInput required formControlName="date" [matDatepicker]="pickerpubdatex" />
                <mat-datepicker-toggle matSuffix [for]="pickerpubdatex"></mat-datepicker-toggle>
                <mat-datepicker #pickerpubdatex></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field style="margin-left: 7%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>जाहिरात सप्रेम भेट</mat-label>
                <input type="number" formControlName="jahiratsbhet" matInput />
              </mat-form-field>
              <mat-form-field style="margin-left: 5%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>अभिकर्ता सप्रेम भेट</mat-label>
                <input type="number" formControlName="issuesbhet" matInput />
              </mat-form-field>
              <mat-form-field style="margin-left: 5%; margin-top: 10px; width: 25%" class="example-full-width"
                appearance="outline">
                <mat-label>वर्गणी सप्रेम भेट</mat-label>
                <input type="number" formControlName="sbhet" matInput />
              </mat-form-field>
            </div>

            <div class="form-row">
              <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 7%">
                <mat-label>जादा अंक</mat-label>
                <input matInput type="text" formControlName="input_value" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 5%">
                <mat-label>जादा विक्री</mat-label>
                <input matInput type="text" formControlName="input_value1" />
              </mat-form-field>
              <mat-form-field class="example-full-width" appearance="outline" style="width: 25%; margin-left: 5%">
                <mat-label>जादा सप्रेमभेट</mat-label>
                <input matInput type="text" formControlName="input_value2" />
              </mat-form-field>
            </div>

            <div class="form-group d-flex">
              <button style="margin-left: 80px; width: 20%" [disabled]="sbhet.invalid" class="btn btn-danger btn-block"
                (click)="addsbhet()">
                Add Saprem Bhet
              </button>
              <button style="width: 20%; margin-left: 80px;" *ngIf="updatesbhet == true"
                class="btn btn-primary btn-block" (click)="updatesbhetdata()">
                Update Saprem Bhet
              </button>
              <div style="width: 20%; margin-left: 80px;">
                <button *ngIf="serachParam!=null" style="background: #b1a3c2;" matTooltip="Make Active"
                  class="btn-sm btn-outline-info" (click)="setOriginalData()" mat-raised-button>
                  <mat-icon>close</mat-icon>{{serachParam}}
                </button>
              </div>
            </div>
          </form>

          <div>
            <div class="tableFixHead">
              <table class="table table-striped" style="width: 120%;">
                <thead style="text-align: center;">
                  <tr>
                    <th>Sr</th>
                    <th>Representative Name</th>
                    <th>Issue Name</th>
                    <th>Start Date</th>
                    <th>जाहिरात</th>
                    <th>अभिकर्ता</th>
                    <th>वर्गणी</th>
                    <th>जादा अंक</th>
                    <th>जादा विक्री</th>
                    <th>जादा सप्रेमभेट</th>
                    <th>एकूण</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody style="text-align: center;">
                  <tr *ngFor="let item of searchData; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{ item['issueSellerName'] }}</td>
                    <td>{{ item['issueName'] }}</td>
                    <td>{{ item.start_date | date: 'dd-MM-yyyy' }} - {{ item.end_date | date: 'dd-MM-yyyy' }}</td>
                    <td>{{ item['jahirat_sbhet'] }}</td>
                    <td>{{ item['issues_bhet'] }}</td>
                    <td>{{ item['s_bhet'] }}</td>
                    <td>{{ item['input_value'] || 0 }}</td>
                    <td>{{ item['input_value1'] || 0 }}</td>
                    <td>{{ item['input_value2'] || 0 }}</td>
                    <td>{{ item['saprembhet_total'] }}</td>
                    <td>
                      <button *ngIf="item.active_status=='DEACTIVE'" style="background: #f5b0b0;"
                        matTooltip="Make Active" class="btn-sm btn-outline-info" mat-raised-button
                        (click)="updateActiveStatus('ACTIVE', item.id)">
                        <mat-icon>close</mat-icon>
                      </button>
                      <button *ngIf="item.active_status=='ACTIVE'" style="background: #a7eba6;"
                        matTooltip="Make Deactive" class="btn-sm btn-outline-info" mat-raised-button
                        (click)="updateActiveStatus('DEACTIVE', item.id)">
                        <mat-icon>check</mat-icon>
                      </button>
                      <button matTooltip="Update" class="btn-sm btn-outline-info" mat-raised-button
                        style="margin-left: 3px;" (click)="updateSbhetData(item)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button matTooltip="Delete" class="btn-sm btn-outline-info" mat-raised-button
                        style="margin-left: 3px;" (click)="deletesbhet(item)">
                        <mat-icon>delete</mat-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-tab>



    <mat-tab label="Office Representative">
      <!-- Search Bar -->
      <div class="or-search-bar">
        <mat-form-field class="or-search-field" appearance="outline">
          <mat-label>Search by Name</mat-label>
          <mat-icon matPrefix>search</mat-icon>
          <input matInput [(ngModel)]="searchName" (ngModelChange)="applyFilterOff()"
            placeholder="Enter representative name…" />
          <button *ngIf="searchName" matSuffix mat-icon-button (click)="searchName = ''; applyFilterOff()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-form-field class="or-search-field" appearance="outline">
          <mat-label>Search by Mobile</mat-label>
          <mat-icon matPrefix>phone</mat-icon>
          <input matInput [(ngModel)]="searchMobile" (ngModelChange)="applyFilterOff()"
            placeholder="Enter mobile number…" />
          <button *ngIf="searchMobile" matSuffix mat-icon-button (click)="searchMobile = ''; applyFilterOff()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <button mat-stroked-button class="or-clear-btn" (click)="clearSearch()">
          <mat-icon>filter_alt_off</mat-icon> Clear
        </button>
      </div>
      <mat-card class="or-card">
        <div class="or-form-header">
          <mat-icon>person_add</mat-icon>
          <span>Add New Representative</span>
        </div>
        <form class="or-form" [formGroup]="officerepform" (ngSubmit)="addofficerepform()">
          <!-- Basic Info -->
          <div class="or-section">
            <div class="or-section-label">
              <mat-icon class="or-section-icon">badge</mat-icon>
              <span>Basic Info</span>
            </div>
            <div class="or-grid-1" style="display: flex; align-items: center; gap: 10px;">

              <!-- Mode Toggle Button -->
              <button mat-icon-button type="button" (click)="toggleRepMode()"
                [matTooltip]="isAddingNewRep ? 'Select Existing' : 'Add New Representative'" color="primary">
                <mat-icon>{{ isAddingNewRep ? 'arrow_drop_down' : 'person_add' }}</mat-icon>
              </button>

              <!-- EXISTING: Dropdown (Select Mode) -->
              <mat-form-field class="or-field" appearance="outline" *ngIf="!isAddingNewRep">
                <mat-label>Office Representative Name</mat-label>
                <mat-select formControlName="issuesellername" (selectionChange)="onRepNameSelect($event)">
                  <mat-option *ngFor="let rep of allRepresentatives" [value]="rep.issuesellername">
                    {{ rep.issuesellername }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- NEW: Text Input (Add Mode) -->
              <mat-form-field class="or-field" appearance="outline" *ngIf="isAddingNewRep">
                <mat-label>Enter New Representative Name</mat-label>
                <input matInput formControlName="issuesellername" placeholder="Type new name...">
              </mat-form-field>

            </div>
            <div class="or-grid-1">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Address</mat-label>
                <textarea matInput placeholder="Street address, area, landmark…" formControlName="address1"></textarea>
              </mat-form-field>
            </div>
          </div>

          <!-- Location -->
          <div class="or-section">
            <div class="or-section-label">
              <mat-icon class="or-section-icon">location_on</mat-icon>
              <span>Location</span>
            </div>
            <div class="or-grid-3">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Pincode</mat-label>
                <input (change)="getPincode2($event)" matInput #postalCode2 maxlength="6" formControlName="pincode"
                  required />
                <mat-hint align="end">{{ postalCode2.value.length }} / 6</mat-hint>
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Country</mat-label>
                <mat-select (selectionChange)="getCountry($event)" formControlName="country" required>
                  <mat-option *ngFor="let c of countries" value="{{ c['country_name'] }}">{{ c["country_name"]
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>State</mat-label>
                <mat-select (selectionChange)="getState($event)" formControlName="state" required>
                  <mat-option *ngFor="let c of states" value="{{ c['state_name'] }}">{{ c["state_name"] }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>District</mat-label>
                <mat-select formControlName="district" (selectionChange)="getDistricts($event)" required>
                  <mat-option *ngFor="let c of cities" value="{{ c['district_name'] }}">{{ c["district_name"]
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Taluka</mat-label>
                <mat-select formControlName="taluka">
                  <mat-option *ngFor="let c of talukas" value="{{ c['taluka_name'] }}">{{ c["taluka_name"]
                    }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Contact -->
          <div class="or-section">
            <div class="or-section-label">
              <mat-icon class="or-section-icon">phone</mat-icon>
              <span>Contact</span>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" [style.color]="validmobile ? null : 'red'" appearance="outline">
                <mat-label>Mobile</mat-label>
                <span matPrefix>+91 &nbsp;</span>
                <input type="tel" #mobile2 (change)="validatemobile($event)" maxlength="10" formControlName="mnumber"
                  matInput />
                <mat-icon matSuffix>call</mat-icon>
                <mat-hint align="end">{{ mobile2.value.length }} / 10</mat-hint>
                <mat-error *ngIf="validmobile">Please enter a valid mobile no.</mat-error>
              </mat-form-field>
              <mat-form-field class="or-field" [style.color]="validemail ? null : 'red'" appearance="outline">
                <mat-label>Email</mat-label>
                <input (change)="validateemail($event)" type="email" matInput formControlName="email"
                  placeholder="Ex. pat@example.com" />
                <mat-icon matSuffix>email</mat-icon>
                <mat-error *ngIf="validemail">Please enter a valid email address</mat-error>
              </mat-form-field>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Landline No.</mat-label>
                <input type="text" #land2 maxlength="12" formControlName="landline_no" matInput />
                <mat-hint align="end">{{ land2.value.length }} / 12</mat-hint>
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Date of Birth</mat-label>
                <input matInput type="date" formControlName="dob" (dateChange)="validateDob($event)" />
                <mat-error *ngIf="validdob">Please enter a valid DOB</mat-error>
              </mat-form-field>
            </div>
          </div>

          <!-- Tax & Identity -->
          <div class="or-section">
            <div class="or-section-label">
              <mat-icon class="or-section-icon">verified_user</mat-icon>
              <span>Tax &amp; Identity</span>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>GST No.</mat-label>
                <input matInput maxlength="15" #gst2 type="text" formControlName="gstno" />
                <mat-hint align="end">{{ gst2.value.length }} / 15</mat-hint>
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>PAN No.</mat-label>
                <input matInput maxlength="10" #pan2 type="text" formControlName="panno" />
                <mat-hint align="end">{{ pan2.value.length }} / 10</mat-hint>
              </mat-form-field>
            </div>
          </div>

          <!-- Tenure -->
          <div class="or-section">
            <div class="or-section-label">
              <mat-icon class="or-section-icon">date_range</mat-icon>
              <span>Tenure</span>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Start Date</mat-label>
                <input matInput type="date" formControlName="start_date" />
              </mat-form-field>
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>End Date</mat-label>
                <input matInput type="date" formControlName="end_date" />
                <mat-hint>Leave blank if currently active</mat-hint>
              </mat-form-field>
            </div>
            <div class="or-grid-2">
              <mat-form-field class="or-field" appearance="outline">
                <mat-label>Status</mat-label>
                <mat-select formControlName="status">
                  <mat-option [value]="1">Active</mat-option>
                  <mat-option [value]="0">Inactive</mat-option>
                </mat-select>
                <mat-icon matPrefix>toggle_on</mat-icon>
              </mat-form-field>
            </div>
          </div>
          <!-- Submit -->

          <!-- Filters Bar -->
          <div class="or-filters-bar">

            <!-- Status Filter — use string values consistently -->
            <mat-form-field appearance="outline" class="or-filter-field">
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="statusFilter" [ngModelOptions]="{standalone: true}"
                (selectionChange)="applyFilterOff()">
                <mat-option value="">All</mat-option>
                <mat-option value="1">Active</mat-option>
                <mat-option value="0">Inactive</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Start Date From -->
            <mat-form-field appearance="outline" class="or-filter-field">
              <mat-label>Start Date From</mat-label>
              <input matInput [matDatepicker]="startFrom" [(ngModel)]="startDateFrom"
                [ngModelOptions]="{standalone: true}" (dateChange)="applyFilterOff()" placeholder="DD/MM/YYYY">
              <mat-datepicker-toggle matSuffix [for]="startFrom"></mat-datepicker-toggle>
              <mat-datepicker #startFrom></mat-datepicker>
            </mat-form-field>

            <!-- Start Date To -->
            <mat-form-field appearance="outline" class="or-filter-field">
              <mat-label>Start Date To</mat-label>
              <input matInput [matDatepicker]="startTo" [(ngModel)]="startDateTo" [ngModelOptions]="{standalone: true}"
                (dateChange)="applyFilterOff()" placeholder="DD/MM/YYYY">
              <mat-datepicker-toggle matSuffix [for]="startTo"></mat-datepicker-toggle>
              <mat-datepicker #startTo></mat-datepicker>
            </mat-form-field>

            <!-- Clear Filters -->
            <button mat-stroked-button class="or-btn-clear" (click)="clearFilters()">
              <mat-icon>filter_alt_off</mat-icon> Clear
            </button>

          </div>
          <!-- Toolbar: Print & Export -->
          <div class="or-table-toolbar">
            <span class="or-table-title">
              <mat-icon>list_alt</mat-icon> Representatives List
            </span>
            <div class="or-toolbar-actions">
              <button mat-stroked-button class="or-btn-print" (click)="printListAddress()">
                <mat-icon>print</mat-icon> Print Address Label
              </button>
              <button mat-stroked-button class="or-btn-print" (click)="printList()">
                <mat-icon>print</mat-icon> Print List
              </button>
              <button mat-stroked-button class="or-btn-export" (click)="exportToExcelOffice()">
                <mat-icon>download</mat-icon> Export Excel
              </button>
            </div>
          </div>

          <!-- Result count -->
          <div class="or-result-count">
            <mat-icon>info_outline</mat-icon>
            {{ filteredRepresentatives.length }} representative(s) found
          </div>

          <!-- Data Table with fixed height + dual scrollbars -->
          <div class="or-table-wrapper">
            <div class="or-table-scroll">
              <table mat-table [dataSource]="officeRepDataSource" class="or-table"
                *ngIf="officeRepDataSource.data.length > 0; else noData">

                <!-- Sr. No -->
                <ng-container matColumnDef="srno">
                  <th mat-header-cell *matHeaderCellDef class="or-col-sr">#</th>
                  <td mat-cell *matCellDef="let row; let i = index" class="or-col-sr">
                    {{ (paginator ? paginator.pageIndex * paginator.pageSize : 0) + i + 1 }}
                  </td>
                </ng-container>

                <!-- Name -->
                <ng-container matColumnDef="issuesellername">
                  <th mat-header-cell *matHeaderCellDef class="or-col-name">Name</th>
                  <td mat-cell *matCellDef="let row" class="or-col-name">
                    <span class="or-name-link" (click)="editRep(row)">{{ row.issuesellername }}</span>
                  </td>
                </ng-container>

                <!-- Mobile -->
                <ng-container matColumnDef="mnumber">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">Mobile</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.mnumber }}</td>
                </ng-container>

                <!-- Address -->
                <ng-container matColumnDef="address">
                  <th mat-header-cell *matHeaderCellDef class="or-col-lg">Address</th>
                  <td mat-cell *matCellDef="let row" class="or-col-lg">{{ row.address || '—' }}</td>
                </ng-container>

                <!-- Pincode -->
                <ng-container matColumnDef="pincode">
                  <th mat-header-cell *matHeaderCellDef class="or-col-sm">Pincode</th>
                  <td mat-cell *matCellDef="let row" class="or-col-sm">{{ row.pincode || '—' }}</td>
                </ng-container>

                <!-- Country -->
                <ng-container matColumnDef="country">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">Country</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.country || '—' }}</td>
                </ng-container>

                <!-- State -->
                <ng-container matColumnDef="state">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">State</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.state || '—' }}</td>
                </ng-container>

                <!-- District -->
                <ng-container matColumnDef="district">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">District</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.district }}</td>
                </ng-container>

                <!-- Taluka -->
                <ng-container matColumnDef="taluka">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">Taluka</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.taluka }}</td>
                </ng-container>

                <!-- Email -->
                <ng-container matColumnDef="email">
                  <th mat-header-cell *matHeaderCellDef class="or-col-lg">Email</th>
                  <td mat-cell *matCellDef="let row" class="or-col-lg">{{ row.email || '—' }}</td>
                </ng-container>

                <!-- Start Date -->
                <ng-container matColumnDef="start_date">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">Start Date</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.start_date || '—' }}</td>
                </ng-container>

                <!-- End Date -->
                <ng-container matColumnDef="end_date">
                  <th mat-header-cell *matHeaderCellDef class="or-col-md">End Date</th>
                  <td mat-cell *matCellDef="let row" class="or-col-md">{{ row.end_date || '—' }}</td>
                </ng-container>

                <!-- Status -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef class="or-col-sm">Status</th>
                  <td mat-cell *matCellDef="let row" class="or-col-sm">
                    <span class="or-badge" [ngClass]="row.status == 1 ? 'or-badge--active' : 'or-badge--inactive'">
                      {{ row.status == 1 ? 'Active' : 'Inactive' }}
                    </span>
                  </td>
                </ng-container>

                <!-- Actions -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef class="or-col-actions">Actions</th>
                  <td mat-cell *matCellDef="let row" class="or-col-actions">
                    <button mat-icon-button class="or-action-edit" matTooltip="Edit" (click)="editRep(row)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button class="or-action-delete" matTooltip="Delete" (click)="deleteRep(row)">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="or-table-row"></tr>
              </table>

              <ng-template #noData>
                <div class="or-no-data">
                  <mat-icon>manage_search</mat-icon>
                  <p>No representatives found matching your search.</p>
                </div>
              </ng-template>
            </div>

            <!-- Paginator outside scroll box -->
            <mat-paginator #paginator *ngIf="officeRepDataSource.data.length > 0" [pageSizeOptions]="[5, 10, 25]"
              pageSize="5" showFirstLastButtons class="or-paginator">
            </mat-paginator>
          </div>

        </form>

        <!-- ═══════════════════════════════════════
         ADD FORM SECTION
    ═══════════════════════════════════════ -->
      </mat-card>
      <div class="seniority-container">

        <!-- ── Form Card ── -->
        <div class="sen-card">
          <div class="sen-card-header">
            <i class="ti ti-award" aria-hidden="true"></i>
            <span style="display: flex; justify-content: center; width: 100%;">
              {{ updatesenioritybtn ? 'Update Seniority' : 'Add Seniority' }}
            </span>
          </div>

          <form [formGroup]="addseni">

            <div class="sen-form-grid">

              <!-- Office Representative -->
              <mat-form-field appearance="outline" class="sen-field">
                <mat-label>Office Representative</mat-label>
                <mat-select formControlName="off_repname">
                  <mat-option *ngFor="let option of getrepname" [value]="option.id">
                    {{ option.officerep }}
                  </mat-option>
                </mat-select>
                <mat-icon matPrefix>person_outline</mat-icon>
              </mat-form-field>

              <!-- Department -->
              <mat-form-field appearance="outline" class="sen-field">
                <mat-label>Department</mat-label>
                <mat-select formControlName="dept">
                  <mat-option *ngFor="let book of getdeptdata" [value]="book.dep_id">
                    {{ book.dep_name }}
                  </mat-option>
                </mat-select>
                <mat-icon matPrefix>business</mat-icon>
              </mat-form-field>

              <!-- Seniority -->
              <mat-form-field appearance="outline" class="sen-field">
                <mat-label>Seniority</mat-label>
                <input matInput formControlName="seniority" placeholder="e.g. 1" />
                <mat-icon matPrefix>sort</mat-icon>
              </mat-form-field>

            </div>
            <!-- ✅ sen-form-grid closes here -->

            <!-- Action Buttons -->
            <div class="sen-actions">
              <button *ngIf="!updatesenioritybtn" type="button" mat-flat-button color="primary" class="sen-btn"
                (click)="addseniority()">
                <mat-icon>add_circle_outline</mat-icon>
                Add Seniority
              </button>

              <ng-container *ngIf="updatesenioritybtn">
                <button type="button" mat-flat-button color="primary" class="sen-btn" (click)="updateseniority()">
                  <mat-icon>save</mat-icon>
                  Save Changes
                </button>
                <button type="button" mat-stroked-button class="sen-btn-cancel" (click)="cancelSeniorityEdit()">
                  <mat-icon>cancel</mat-icon>
                  Cancel
                </button>
              </ng-container>
            </div>

          </form>
          <!-- ✅ form closes inside sen-card -->

        </div>
        <!-- ✅ sen-card (form) closes here -->

        <!-- ── Table Card ── -->
        <div class="sen-card">
          <div class="sen-card-header">
            <i class="ti ti-list" aria-hidden="true"></i>
            <span>Seniority List</span>
            <span class="sen-badge">{{ senioritylist?.length || 0 }}</span>
          </div>

          <div class="sen-table-wrap">
            <table class="sen-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Department</th>
                  <th>Office Representative</th>
                  <th>Seniority</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!senioritylist?.length">
                  <td colspan="5" class="sen-empty">
                    <i class="ti ti-inbox" aria-hidden="true"></i>
                    No records found
                  </td>
                </tr>
                <tr *ngFor="let item of senioritylist; let i = index" [class.sen-row-active]="editingRowId === item.id">
                  <td>{{ i + 1 }}</td>
                  <td>{{ item.dep_name || item.dep_id }}</td>
                  <td>{{ item.officerep }}</td>
                  <td><span class="sen-seniority-badge">{{ item.seniority }}</span></td>
                  <td class="sen-action-cell">
                    <button mat-icon-button color="primary" matTooltip="Edit" (click)="editSeniority(item)">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button mat-icon-button color="warn" matTooltip="Delete" (click)="confirmDeleteSeniority(item.id)">
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- ✅ table card closes here -->

      </div>
      <!-- ✅ seniority-container closes here -->

    </mat-tab>

    <mat-tab label="Assign Representative">
      <div class="ar-wrapper" (mousemove)="onMouseMove($event)">

        <!-- Cursor Elements -->
        <div id="cursor-glow"></div>
        <div id="cursor-dot"></div>
        <div id="cursor-ring"></div>
        <div id="cursor-label"></div>

        <!-- ========== BANNER ========== -->
        <div class="ar-banner">
          <div class="ar-banner-icon"><mat-icon>assignment_ind</mat-icon></div>
          <div>
            <h2 class="ar-banner-title">Assign Representative</h2>
            <p class="ar-banner-sub">MANAGE · ASSIGN · REPRESENTATIVE · BOOKSTORE · SUBSCRIPTION</p>
          </div>
        </div>

        <!-- ========== FORM CARD ========== -->
        <div class="ar-card ar-card-form">
          <form [formGroup]="repassignform" (ngSubmit)="addassignrep()">

            <div class="ar-section-label"><span>Representative Info</span></div>

            <div class="ar-form-grid ar-grid-3">
              <div class="ar-field-group">
                <label class="ar-label">Representative</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="rep" [matAutocomplete]="auto" placeholder="Search representative..."
                    required />
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" panelWidth="auto">
                    <mat-option (onSelectionChange)="selected_name($event, option)"
                      *ngFor="let option of filteredOptions6 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="ar-field-group">
                <label class="ar-label">District</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="district" placeholder="District" />
                </mat-form-field>
              </div>
              <div class="ar-field-group">
                <label class="ar-label">Taluka</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="taluka" placeholder="Taluka" />
                </mat-form-field>
              </div>
            </div>

            <div class="ar-section-label"><span>Assignment Details</span></div>

            <div class="ar-form-grid ar-grid-4">
              <div class="ar-field-group">
                <label class="ar-label">Book Store</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="bookstore" [matAutocomplete]="auto7"
                    placeholder="Search book store..." required />
                  <mat-autocomplete autoActiveFirstOption #auto7="matAutocomplete" panelWidth="auto">
                    <mat-option (onSelectionChange)="selected_bookstore(option)"
                      *ngFor="let option of filteredOptions7 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="ar-field-group">
                <label class="ar-label">Subscription</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="subscription" [matAutocomplete]="auto8"
                    placeholder="Search subscription..." required />
                  <mat-autocomplete autoActiveFirstOption #auto8="matAutocomplete" panelWidth="auto">
                    <mat-option (onSelectionChange)="selected_subs(option)"
                      *ngFor="let option of filteredOptions8 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="ar-field-group">
                <label class="ar-label">Advertisement</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="advt" [matAutocomplete]="auto9" placeholder="Search advertisement..."
                    required />
                  <mat-autocomplete autoActiveFirstOption #auto9="matAutocomplete" panelWidth="auto">
                    <mat-option (onSelectionChange)="selected_advt(option)"
                      *ngFor="let option of filteredOptions9 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              <div class="ar-field-group">
                <label class="ar-label">Issue / Granth Seller</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <input matInput formControlName="issue" [matAutocomplete]="auto10"
                    placeholder="Search issue seller..." required />
                  <mat-autocomplete autoActiveFirstOption #auto10="matAutocomplete" panelWidth="auto">
                    <mat-option (onSelectionChange)="selected_issue(option)"
                      *ngFor="let option of filteredOptions10 | async" [value]="option['name']">
                      {{ option["name"] }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>

            <div class="ar-btn-row">
              <button *ngIf="!isdata" type="submit" class="ar-btn-primary" (mouseenter)="cursorEnter()"
                (mouseleave)="cursorLeave()">
                <mat-icon>check_circle</mat-icon> Submit
              </button>
              <button *ngIf="isdata" type="button" (click)="updateassignrep()" class="ar-btn-outline"
                (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                <mat-icon>edit</mat-icon> Update
              </button>
            </div>

          </form>
        </div>

        <!-- ========== LIST 1: Assign Representative ========== -->
        <div class="ar-card ar-card-table ar-mt">
          <div class="ar-card-header">
            <div class="ar-card-title">
              <span class="ar-title-icon"><mat-icon>list_alt</mat-icon></span>
              List of Assign Representative
            </div>
            <div class="ar-action-group">
              <button type="button" class="ar-btn-export" (click)="exportToExcelAssignRep()"
                (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                <mat-icon>table_view</mat-icon> Export
              </button>
              <button type="button" class="ar-btn-print" (click)="printSection3('repListSection2')"
                (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                <mat-icon>print</mat-icon> Print
              </button>
            </div>
          </div>
          <div class="ar-table-wrap" id="repListSection2">
            <table class="ar-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Representative Name</th>
                  <th>Book Store</th>
                  <th>Subscription</th>
                  <th>Advertisement</th>
                  <th>Issue Sale</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of deptwise_off_rep_list; let i = index">
                  <td><span class="ar-sr-badge">{{ i + 1 }}</span></td>
                  <td>{{ item["rep_name"] }}</td>
                  <td>{{ item["book_off_rep_name"] }}</td>
                  <td>{{ item["sub_off_rep_name"] }}</td>
                  <td>{{ item["advt_off_rep_name"] }}</td>
                  <td>{{ item["issue_off_rep_name"] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ========== LIST 2: Representative Wise Type ========== -->
        <div class="ar-card ar-card-table ar-mt">
          <div class="ar-card-header">
            <div class="ar-card-title">
              <span class="ar-title-icon"><mat-icon>group</mat-icon></span>
              Assign Representative Wise Type
            </div>
          </div>
          <div class="ar-filter-row">
            <form [formGroup]="repassigntype"
              style="display:flex;align-items:flex-end;gap:12px;flex-wrap:wrap;width:100%;">
              <div class="ar-field-group ar-filter-select">
                <label class="ar-label">Select Type</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <mat-select formControlName="type" (selectionChange)="onSelectionChange()">
                    <mat-option *ngFor="let option of getdepwiserepcount1" [value]="option.rep_type">
                      {{ option.rep_type }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="ar-count-badge">
                <mat-icon>tag</mat-icon>
                Total Count: <strong>{{ getdatabydep?.length || 0 }}</strong>
              </div>
              <div class="ar-action-group ar-filter-actions">
                <button type="button" class="ar-btn-export" (click)="exportToExcel()" (mouseenter)="cursorEnter()"
                  (mouseleave)="cursorLeave()">
                  <mat-icon>table_view</mat-icon> Export
                </button>
                <button type="button" class="ar-btn-print"
                  (click)="printSection2('repListSection1', repassigntype.get('type')?.value)"
                  (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                  <mat-icon>print</mat-icon> Print Label
                </button>
                <button type="button" class="ar-btn-print"
                  (click)="printSectionAddressList('repListSection1', repassigntype.get('type')?.value)"
                  (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                  <mat-icon>print</mat-icon> Print List
                </button>
              </div>
            </form>
          </div>
          <div class="ar-table-wrap" id="repListSection1">
            <table class="ar-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Off. Representative</th>
                  <th>Rep. Name</th>
                  <th>Address</th>
                  <th>Taluka</th>
                  <th>District</th>
                  <th>Pincode</th>
                  <th>State</th>
                  <th>Mobile</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getdatabydep; let i = index">
                  <td><span class="ar-sr-badge">{{ i + 1 }}</span></td>
                  <td>{{ item["office_rep_name"] }}</td>
                  <td>{{ item["representative_name"] }}</td>
                  <td>{{ item["address"] }}</td>
                  <td>{{ item["taluka"] }}</td>
                  <td>{{ item["district"] }}</td>
                  <td>{{ item["pincode"] }}</td>
                  <td>{{ item["state"] }}</td>
                  <td>{{ item["mobile_no"] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ========== LIST 3: Office Representative Wise ========== -->
        <div class="ar-card ar-card-table ar-mt ar-mb">
          <div class="ar-card-header">
            <div class="ar-card-title">
              <span class="ar-title-icon">
                <mat-icon>supervised_user_circle</mat-icon>
              </span>
              Assign Representative — Office Rep Wise
            </div>
          </div>
          <div class="ar-filter-row">
            <form [formGroup]="repassignoff"
              style="display:flex;align-items:flex-end;gap:12px;flex-wrap:wrap;width:100%;">
              <div class="ar-field-group ar-filter-select ar-filter-select-lg">
                <label class="ar-label">Select Office Representative</label>
                <mat-form-field class="ar-field" appearance="outline">
                  <mat-select formControlName="off_rep" multiple (selectionChange)="assignoffwithoffrep()">
                    <mat-option *ngFor="let option of getrepname" [value]="option.id">
                      {{ option.officerep }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="ar-count-badge">
                <mat-icon>tag</mat-icon>
                Total Count: <strong>{{ totalCount }}</strong>
              </div>
              <div class="ar-action-group ar-filter-actions">
                <button type="button" class="ar-btn-export" (click)="exportToExcelOffRep()" (mouseenter)="cursorEnter()"
                  (mouseleave)="cursorLeave()">
                  <mat-icon>table_view</mat-icon> Export
                </button>
                <button type="button" class="ar-btn-print"
                  (click)="printSection1('repListSection', getSelectedRepNames())" (mouseenter)="cursorEnter()"
                  (mouseleave)="cursorLeave()">
                  <mat-icon>print</mat-icon> Print Label
                </button>
                <button type="button" class="ar-btn-print"
                  (click)="printSectionAddressList1('repListSection', getSelectedRepNames())"
                  (mouseenter)="cursorEnter()" (mouseleave)="cursorLeave()">
                  <mat-icon>print</mat-icon> Print List
                </button>
              </div>
            </form>
          </div>
          <div class="ar-table-wrap" id="repListSection">
            <table class="ar-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Representative Name</th>
                  <th>Address</th>
                  <th>Mobile No.</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of getdatabyoff; let i = index">
                  <td><span class="ar-sr-badge">{{ i + 1 }}</span></td>
                  <td>{{ item["rep_name"] }}</td>
                  <td>
                    {{ item["rep_address"] }} {{ item["rep_taluka"] }}
                    {{ item["rep_district"] }} {{ item["pincode"] }}
                    {{ item["rep_state"] }}
                  </td>
                  <td>{{ item["mobile_no"] }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </mat-tab>



    <mat-tab label="Add Language">
      <mat-card class="card mt-5">
        <form [formGroup]="addlang">
          <div class="form-row mt-3">
            <mat-form-field class="example-full-width" style="width: 25%; margin-left: 5%" appearance="outline">
              <mat-label>Add Language :</mat-label>
              <input matInput formControlName="language" required />
            </mat-form-field>

          </div>

          <div>
            <button type="button" (click)="addlanguage()" class="btn btn-primary" style="width: 10%; margin-left: 36%;">
              Add
            </button>

          </div>
          <div>

          </div>
        </form>

        <div class="tableFixHead">
          <table class="table table-striped text-center">
            <thead>
              <tr>
                <th>Sr. no.</th>
                <th>Language</th>
                <!-- <th>OffReprensantive Name</th> -->
                <!-- <th>Seniority</th> -->
                <th>Action</th>

              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of languagelist; let i = index">
                <!-- <td>{{ i + 1 }}</td> -->
                <td>{{ item["id"] }}</td>
                <!-- <td>{{ item["district"] }}</td>
                      <td>{{ item["taluka"] }}</td> -->
                <td>{{ item["Languages"] }}</td>
                <!-- <td>{{ item["seniority"] }}</td> -->

                <td>

                  <button type="button" style="margin-left: 5%;" type="button" class="btn btn-primary"
                    matTooltip="Update" (click)="deleteseniority(item.id)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </mat-card>

    </mat-tab>


    <mat-tab label="Manage Titles">
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important">
        <div style="margin-top: 20px">
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">Add New Titles</h1>
          </div>
          <form class="form" [formGroup]="MasterTable" (ngSubmit)="save()">
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px">Title :</label>
                <input required style="width: 90%; margin-left: 35px" formControlName="title" type="text"
                  class="form-control" placeholder="" />
              </div>
              <!-- form-group end.// -->
            </div>

            <div class="form-group">
              <button [disabled]="MasterTable.invalid" style="margin-right: 27%; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add new title
              </button>
            </div>
            <!-- form-group// -->
          </form>
        </div>

        <div class="tableFixHead">
          <table class="table table-striped text-center table-fixed">
            <thead>
              <th>Sr.No.</th>
              <th>Title</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.titles; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item["title"] }}</td>
                <td>
                  <button type="button" class="btn-danger btn-sm" (click)="removeTitle(item['title'])">
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Manage Occupation">
      <div class="add-new-subscriber mat-elevation-z4" style="overflow-x: scroll !important">
        <div style="margin-top: 20px">
          <div class="text-center">
            <h1 style="font-size: medium; font-weight: bold">
              Add New Occupation
            </h1>
          </div>
          <form class="form" [formGroup]="OccupationMaster" (ngSubmit)="save_occupation()">
            <div class="form-row">
              <div class="col form-group">
                <label style="margin-left: 35px; margin-top: 20px">Occupation :</label>
                <input required style="width: 90%; margin-left: 35px" formControlName="occupation" type="text"
                  class="form-control" placeholder="" />
              </div>
              <!-- form-group end.// -->
            </div>

            <div class="form-group">
              <button [disabled]="OccupationMaster.invalid" style="margin-right: 27%; width: 40%" type="submit"
                class="btn btn-danger btn-block">
                Add new occupation
              </button>
            </div>
            <!-- form-group// -->
          </form>
        </div>

        <div style="margin-top: 20%" class="tableFixHead">
          <table class="table table-striped text-center table-fixed">
            <thead>
              <th>Sr.No.</th>
              <th>Occupation</th>
              <th>Action</th>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.occupations; let i = index">
                <td>{{ i + 1 }}</td>
                <td>{{ item["occupation"] }}</td>
                <td>
                  <button type="button" class="btn-danger btn-sm" (click)="removeOccupdation(item['occupation'])">
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>

  </mat-tab-group>
</div>